/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as LoginRouteImport } from "./routes/login"
import { Route as AuthedRouteRouteImport } from "./routes/_authed/route"
import { Route as AuthedIndexRouteImport } from "./routes/_authed/index"
import { Route as FormsFlowIdRouteImport } from "./routes/forms.$flowId"
import { Route as AuthCallbackRouteImport } from "./routes/auth/callback"
import { Route as AuthedModalRouteRouteImport } from "./routes/_authed/_modal/route"
import { Route as AuthedWorkspaceIndexRouteImport } from "./routes/_authed/workspace/index"
import { Route as PublicVoiceReportTokenRouteImport } from "./routes/public.voice-report.$token"
import { Route as ConnectSpaceSpaceIdRouteImport } from "./routes/connect.space.$spaceId"
import { Route as ConnectInviteTokenRouteImport } from "./routes/connect.invite.$token"
import { Route as ConnectChatbotPublicTokenRouteImport } from "./routes/connect.chatbot.$publicToken"
import { Route as AuthedWorkspaceWorkRouteImport } from "./routes/_authed/workspace/work"
import { Route as AuthedWorkspaceTechnicalRouteImport } from "./routes/_authed/workspace/technical"
import { Route as AuthedWorkspaceSharesRouteImport } from "./routes/_authed/workspace/shares"
import { Route as AuthedWorkspaceSalesRouteImport } from "./routes/_authed/workspace/sales"
import { Route as AuthedWorkspaceFlowsRouteImport } from "./routes/_authed/workspace/flows"
import { Route as AuthedWorkspaceFinanceRouteImport } from "./routes/_authed/workspace/finance"
import { Route as AuthedWorkspaceDxfLibraryRouteImport } from "./routes/_authed/workspace/dxf-library"
import { Route as AuthedWorkspaceDocumentsRouteImport } from "./routes/_authed/workspace/documents"
import { Route as AuthedWorkspaceDashboardRouteImport } from "./routes/_authed/workspace/dashboard"
import { Route as AuthedWorkspaceConversationsRouteImport } from "./routes/_authed/workspace/conversations"
import { Route as AuthedWorkspaceConnectRouteImport } from "./routes/_authed/workspace/connect"
import { Route as AuthedWorkspaceCleanControlRouteImport } from "./routes/_authed/workspace/clean-control"
import { Route as AuthedWorkspaceCanvasesRouteImport } from "./routes/_authed/workspace/canvases"
import { Route as AuthedWorkspaceCalendarRouteImport } from "./routes/_authed/workspace/calendar"
import { Route as AuthedWorkspaceAutomationsRouteImport } from "./routes/_authed/workspace/automations"
import { Route as AuthedWorkspaceTemplatesRouteRouteImport } from "./routes/_authed/workspace/templates/route"
import { Route as AuthedWorkspaceReportsRouteRouteImport } from "./routes/_authed/workspace/reports/route"
import { Route as AuthedWorkspaceProjectsRouteRouteImport } from "./routes/_authed/workspace/projects/route"
import { Route as AuthedWorkspaceIntegrationsRouteRouteImport } from "./routes/_authed/workspace/integrations/route"
import { Route as AuthedModalSettingsRouteRouteImport } from "./routes/_authed/_modal/settings/route"
import { Route as AuthedModalIntegrationsRouteRouteImport } from "./routes/_authed/_modal/integrations/route"
import { Route as AuthedModalConsoleRouteRouteImport } from "./routes/_authed/_modal/console/route"
import { Route as AuthedModalAdminRouteRouteImport } from "./routes/_authed/_modal/admin/route"
import { Route as AuthedWorkspaceTemplatesIndexRouteImport } from "./routes/_authed/workspace/templates/index"
import { Route as AuthedWorkspaceReportsIndexRouteImport } from "./routes/_authed/workspace/reports/index"
import { Route as AuthedWorkspaceProjectsIndexRouteImport } from "./routes/_authed/workspace/projects/index"
import { Route as AuthedWorkspaceIntegrationsIndexRouteImport } from "./routes/_authed/workspace/integrations/index"
import { Route as AuthedWorkspaceFlowsIndexRouteImport } from "./routes/_authed/workspace/flows.index"
import { Route as AuthedWorkspaceConnectIndexRouteImport } from "./routes/_authed/workspace/connect.index"
import { Route as AuthedModalSettingsIndexRouteImport } from "./routes/_authed/_modal/settings/index"
import { Route as AuthedModalIntegrationsIndexRouteImport } from "./routes/_authed/_modal/integrations/index"
import { Route as AuthedModalConsoleIndexRouteImport } from "./routes/_authed/_modal/console/index"
import { Route as AuthedModalAdminIndexRouteImport } from "./routes/_authed/_modal/admin/index"
import { Route as AuthedWorkspaceTemplatesKindRouteImport } from "./routes/_authed/workspace/templates/$kind"
import { Route as AuthedWorkspaceReportsReportIdRouteImport } from "./routes/_authed/workspace/reports/$reportId"
import { Route as AuthedWorkspaceProjectsProjectIdRouteImport } from "./routes/_authed/workspace/projects/$projectId"
import { Route as AuthedWorkspaceIntegrationsCapabilityRouteImport } from "./routes/_authed/workspace/integrations/$capability"
import { Route as AuthedWorkspaceFlowsFlowIdRouteImport } from "./routes/_authed/workspace/flows.$flowId"
import { Route as AuthedWorkspaceDashboardDashboardIdRouteImport } from "./routes/_authed/workspace/dashboard_.$dashboardId"
import { Route as AuthedWorkspaceConnectSpaceIdRouteImport } from "./routes/_authed/workspace/connect.$spaceId"
import { Route as AuthedWorkspaceCanvasesCanvasIdRouteImport } from "./routes/_authed/workspace/canvases.$canvasId"
import { Route as AuthedModalSettingsSkillsRouteImport } from "./routes/_authed/_modal/settings/skills"
import { Route as AuthedModalSettingsShortcutsRouteImport } from "./routes/_authed/_modal/settings/shortcuts"
import { Route as AuthedModalSettingsSecurityRouteImport } from "./routes/_authed/_modal/settings/security"
import { Route as AuthedModalSettingsPrivacyRouteImport } from "./routes/_authed/_modal/settings/privacy"
import { Route as AuthedModalSettingsPresentationsRouteImport } from "./routes/_authed/_modal/settings/presentations"
import { Route as AuthedModalSettingsOrganizationRouteImport } from "./routes/_authed/_modal/settings/organization"
import { Route as AuthedModalSettingsNotificationsRouteImport } from "./routes/_authed/_modal/settings/notifications"
import { Route as AuthedModalSettingsModesRouteImport } from "./routes/_authed/_modal/settings/modes"
import { Route as AuthedModalSettingsMemoryRouteImport } from "./routes/_authed/_modal/settings/memory"
import { Route as AuthedModalSettingsMarpTemplatesRouteImport } from "./routes/_authed/_modal/settings/marp-templates"
import { Route as AuthedModalSettingsHelpRouteImport } from "./routes/_authed/_modal/settings/help"
import { Route as AuthedModalSettingsChangelogRouteImport } from "./routes/_authed/_modal/settings/changelog"
import { Route as AuthedModalSettingsBrandKitsRouteImport } from "./routes/_authed/_modal/settings/brand-kits"
import { Route as AuthedModalSettingsBillingRouteImport } from "./routes/_authed/_modal/settings/billing"
import { Route as AuthedModalIntegrationsCapabilityRouteImport } from "./routes/_authed/_modal/integrations/$capability"
import { Route as AuthedModalEngineGetStartedRouteImport } from "./routes/_authed/_modal/engine/get-started"
import { Route as AuthedModalConsoleUsageRouteImport } from "./routes/_authed/_modal/console/usage"
import { Route as AuthedModalConsoleTracesRouteImport } from "./routes/_authed/_modal/console/traces"
import { Route as AuthedModalConsoleSchemaRouteImport } from "./routes/_authed/_modal/console/schema"
import { Route as AuthedModalConsolePlaygroundRouteImport } from "./routes/_authed/_modal/console/playground"
import { Route as AuthedModalConsoleModelsRouteImport } from "./routes/_authed/_modal/console/models"
import { Route as AuthedModalConsoleMembersRouteImport } from "./routes/_authed/_modal/console/members"
import { Route as AuthedModalConsoleLimitsRouteImport } from "./routes/_authed/_modal/console/limits"
import { Route as AuthedModalConsoleGetStartedRouteImport } from "./routes/_authed/_modal/console/get-started"
import { Route as AuthedModalConsoleEmbeddedIdentityRouteImport } from "./routes/_authed/_modal/console/embedded-identity"
import { Route as AuthedModalConsoleDocumentsRouteImport } from "./routes/_authed/_modal/console/documents"
import { Route as AuthedModalConsoleDocsRouteImport } from "./routes/_authed/_modal/console/docs"
import { Route as AuthedModalConsoleDevelopersRouteImport } from "./routes/_authed/_modal/console/developers"
import { Route as AuthedModalConsoleBillingRouteImport } from "./routes/_authed/_modal/console/billing"
import { Route as AuthedModalConsoleAppsRouteImport } from "./routes/_authed/_modal/console/apps"
import { Route as AuthedModalConsoleActionsRouteImport } from "./routes/_authed/_modal/console/actions"
import { Route as AuthedModalConsoleAccountsRouteImport } from "./routes/_authed/_modal/console/accounts"
import { Route as AuthedModalConsoleAccessRouteImport } from "./routes/_authed/_modal/console/access"
import { Route as AuthedModalAdminRevenueRouteImport } from "./routes/_authed/_modal/admin/revenue"
import { Route as AuthedModalAdminQualityRouteImport } from "./routes/_authed/_modal/admin/quality"
import { Route as AuthedModalAdminPricingMarkupRouteImport } from "./routes/_authed/_modal/admin/pricing-markup"
import { Route as AuthedModalAdminPreventiviRouteImport } from "./routes/_authed/_modal/admin/preventivi"
import { Route as AuthedModalAdminPresentazioniRouteImport } from "./routes/_authed/_modal/admin/presentazioni"
import { Route as AuthedModalAdminPlatformSettingsRouteImport } from "./routes/_authed/_modal/admin/platform-settings"
import { Route as AuthedModalAdminHypermemRouteImport } from "./routes/_authed/_modal/admin/hypermem"
import { Route as AuthedModalAdminHealthRouteImport } from "./routes/_authed/_modal/admin/health"
import { Route as AuthedModalAdminEngagementRouteImport } from "./routes/_authed/_modal/admin/engagement"
import { Route as AuthedModalAdminDemoInvitiRouteImport } from "./routes/_authed/_modal/admin/demo-inviti"
import { Route as AuthedModalAdminCostTrackingRouteImport } from "./routes/_authed/_modal/admin/cost-tracking"
import { Route as AuthedModalAdminCanvasRouteImport } from "./routes/_authed/_modal/admin/canvas"
import { Route as AuthedModalAdminBillingRouteImport } from "./routes/_authed/_modal/admin/billing"
import { Route as AuthedModalAdminAutomationRouteImport } from "./routes/_authed/_modal/admin/automation"
import { Route as AuthedModalConsoleKeysIndexRouteImport } from "./routes/_authed/_modal/console/keys.index"
import { Route as AuthedModalConsoleFlowsIndexRouteImport } from "./routes/_authed/_modal/console/flows.index"
import { Route as AuthedModalConsoleConnectorsIndexRouteImport } from "./routes/_authed/_modal/console/connectors.index"
import { Route as AuthedModalAdminUsersIndexRouteImport } from "./routes/_authed/_modal/admin/users/index"
import { Route as AuthedModalAdminOrgsIndexRouteImport } from "./routes/_authed/_modal/admin/orgs/index"
import { Route as AuthedWorkspaceTemplatesEditSlugRouteImport } from "./routes/_authed/workspace/templates/edit.$slug"
import { Route as AuthedWorkspaceFlowsFlowIdRunRouteImport } from "./routes/_authed/workspace/flows.$flowId_.run"
import { Route as AuthedModalConsoleKeysKeyIdRouteImport } from "./routes/_authed/_modal/console/keys.$keyId"
import { Route as AuthedModalConsoleFlowsFlowIdRouteImport } from "./routes/_authed/_modal/console/flows.$flowId"
import { Route as AuthedModalConsoleDocumentAccessDocumentIdRouteImport } from "./routes/_authed/_modal/console/document-access.$documentId"
import { Route as AuthedModalConsoleConnectorsConnectionIdRouteImport } from "./routes/_authed/_modal/console/connectors.$connectionId"
import { Route as AuthedModalConsoleConnectionAccessConnectionIdRouteImport } from "./routes/_authed/_modal/console/connection-access.$connectionId"
import { Route as AuthedModalAdminUsersUserIdRouteImport } from "./routes/_authed/_modal/admin/users/$userId"
import { Route as AuthedModalAdminOrgsOrgIdRouteImport } from "./routes/_authed/_modal/admin/orgs/$orgId"

const LoginRoute = LoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRouteRoute = AuthedRouteRouteImport.update({
  id: "/_authed",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthedRouteRoute,
} as any)
const FormsFlowIdRoute = FormsFlowIdRouteImport.update({
  id: "/forms/$flowId",
  path: "/forms/$flowId",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: "/auth/callback",
  path: "/auth/callback",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedModalRouteRoute = AuthedModalRouteRouteImport.update({
  id: "/_modal",
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedWorkspaceIndexRoute = AuthedWorkspaceIndexRouteImport.update({
  id: "/workspace/",
  path: "/workspace/",
  getParentRoute: () => AuthedRouteRoute,
} as any)
const PublicVoiceReportTokenRoute = PublicVoiceReportTokenRouteImport.update({
  id: "/public/voice-report/$token",
  path: "/public/voice-report/$token",
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectSpaceSpaceIdRoute = ConnectSpaceSpaceIdRouteImport.update({
  id: "/connect/space/$spaceId",
  path: "/connect/space/$spaceId",
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectInviteTokenRoute = ConnectInviteTokenRouteImport.update({
  id: "/connect/invite/$token",
  path: "/connect/invite/$token",
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectChatbotPublicTokenRoute =
  ConnectChatbotPublicTokenRouteImport.update({
    id: "/connect/chatbot/$publicToken",
    path: "/connect/chatbot/$publicToken",
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthedWorkspaceWorkRoute = AuthedWorkspaceWorkRouteImport.update({
  id: "/workspace/work",
  path: "/workspace/work",
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedWorkspaceTechnicalRoute =
  AuthedWorkspaceTechnicalRouteImport.update({
    id: "/workspace/technical",
    path: "/workspace/technical",
    getParentRoute: () => AuthedRouteRoute,
  } as any)
const AuthedWorkspaceSharesRoute = AuthedWorkspaceSharesRouteImport.update({
  id: "/workspace/shares",
  path: "/workspace/shares",
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedWorkspaceSalesRoute = AuthedWorkspaceSalesRouteImport.update({
  id: "/workspace/sales",
  path: "/workspace/sales",
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedWorkspaceFlowsRoute = AuthedWorkspaceFlowsRouteImport.update({
  id: "/workspace/flows",
  path: "/workspace/flows",
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedWorkspaceFinanceRoute = AuthedWorkspaceFinanceRouteImport.update({
  id: "/workspace/finance",
  path: "/workspace/finance",
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedWorkspaceDxfLibraryRoute =
  AuthedWorkspaceDxfLibraryRouteImport.update({
    id: "/workspace/dxf-library",
    path: "/workspace/dxf-library",
    getParentRoute: () => AuthedRouteRoute,
  } as any)
const AuthedWorkspaceDocumentsRoute =
  AuthedWorkspaceDocumentsRouteImport.update({
    id: "/workspace/documents",
    path: "/workspace/documents",
    getParentRoute: () => AuthedRouteRoute,
  } as any)
const AuthedWorkspaceDashboardRoute =
  AuthedWorkspaceDashboardRouteImport.update({
    id: "/workspace/dashboard",
    path: "/workspace/dashboard",
    getParentRoute: () => AuthedRouteRoute,
  } as any)
const AuthedWorkspaceConversationsRoute =
  AuthedWorkspaceConversationsRouteImport.update({
    id: "/workspace/conversations",
    path: "/workspace/conversations",
    getParentRoute: () => AuthedRouteRoute,
  } as any)
const AuthedWorkspaceConnectRoute = AuthedWorkspaceConnectRouteImport.update({
  id: "/workspace/connect",
  path: "/workspace/connect",
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedWorkspaceCleanControlRoute =
  AuthedWorkspaceCleanControlRouteImport.update({
    id: "/workspace/clean-control",
    path: "/workspace/clean-control",
    getParentRoute: () => AuthedRouteRoute,
  } as any)
const AuthedWorkspaceCanvasesRoute = AuthedWorkspaceCanvasesRouteImport.update({
  id: "/workspace/canvases",
  path: "/workspace/canvases",
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedWorkspaceCalendarRoute = AuthedWorkspaceCalendarRouteImport.update({
  id: "/workspace/calendar",
  path: "/workspace/calendar",
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedWorkspaceAutomationsRoute =
  AuthedWorkspaceAutomationsRouteImport.update({
    id: "/workspace/automations",
    path: "/workspace/automations",
    getParentRoute: () => AuthedRouteRoute,
  } as any)
const AuthedWorkspaceTemplatesRouteRoute =
  AuthedWorkspaceTemplatesRouteRouteImport.update({
    id: "/workspace/templates",
    path: "/workspace/templates",
    getParentRoute: () => AuthedRouteRoute,
  } as any)
const AuthedWorkspaceReportsRouteRoute =
  AuthedWorkspaceReportsRouteRouteImport.update({
    id: "/workspace/reports",
    path: "/workspace/reports",
    getParentRoute: () => AuthedRouteRoute,
  } as any)
const AuthedWorkspaceProjectsRouteRoute =
  AuthedWorkspaceProjectsRouteRouteImport.update({
    id: "/workspace/projects",
    path: "/workspace/projects",
    getParentRoute: () => AuthedRouteRoute,
  } as any)
const AuthedWorkspaceIntegrationsRouteRoute =
  AuthedWorkspaceIntegrationsRouteRouteImport.update({
    id: "/workspace/integrations",
    path: "/workspace/integrations",
    getParentRoute: () => AuthedRouteRoute,
  } as any)
const AuthedModalSettingsRouteRoute =
  AuthedModalSettingsRouteRouteImport.update({
    id: "/settings",
    path: "/settings",
    getParentRoute: () => AuthedModalRouteRoute,
  } as any)
const AuthedModalIntegrationsRouteRoute =
  AuthedModalIntegrationsRouteRouteImport.update({
    id: "/integrations",
    path: "/integrations",
    getParentRoute: () => AuthedModalRouteRoute,
  } as any)
const AuthedModalConsoleRouteRoute = AuthedModalConsoleRouteRouteImport.update({
  id: "/console",
  path: "/console",
  getParentRoute: () => AuthedModalRouteRoute,
} as any)
const AuthedModalAdminRouteRoute = AuthedModalAdminRouteRouteImport.update({
  id: "/admin",
  path: "/admin",
  getParentRoute: () => AuthedModalRouteRoute,
} as any)
const AuthedWorkspaceTemplatesIndexRoute =
  AuthedWorkspaceTemplatesIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthedWorkspaceTemplatesRouteRoute,
  } as any)
const AuthedWorkspaceReportsIndexRoute =
  AuthedWorkspaceReportsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthedWorkspaceReportsRouteRoute,
  } as any)
const AuthedWorkspaceProjectsIndexRoute =
  AuthedWorkspaceProjectsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthedWorkspaceProjectsRouteRoute,
  } as any)
const AuthedWorkspaceIntegrationsIndexRoute =
  AuthedWorkspaceIntegrationsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthedWorkspaceIntegrationsRouteRoute,
  } as any)
const AuthedWorkspaceFlowsIndexRoute =
  AuthedWorkspaceFlowsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthedWorkspaceFlowsRoute,
  } as any)
const AuthedWorkspaceConnectIndexRoute =
  AuthedWorkspaceConnectIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthedWorkspaceConnectRoute,
  } as any)
const AuthedModalSettingsIndexRoute =
  AuthedModalSettingsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthedModalSettingsRouteRoute,
  } as any)
const AuthedModalIntegrationsIndexRoute =
  AuthedModalIntegrationsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthedModalIntegrationsRouteRoute,
  } as any)
const AuthedModalConsoleIndexRoute = AuthedModalConsoleIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthedModalConsoleRouteRoute,
} as any)
const AuthedModalAdminIndexRoute = AuthedModalAdminIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthedModalAdminRouteRoute,
} as any)
const AuthedWorkspaceTemplatesKindRoute =
  AuthedWorkspaceTemplatesKindRouteImport.update({
    id: "/$kind",
    path: "/$kind",
    getParentRoute: () => AuthedWorkspaceTemplatesRouteRoute,
  } as any)
const AuthedWorkspaceReportsReportIdRoute =
  AuthedWorkspaceReportsReportIdRouteImport.update({
    id: "/$reportId",
    path: "/$reportId",
    getParentRoute: () => AuthedWorkspaceReportsRouteRoute,
  } as any)
const AuthedWorkspaceProjectsProjectIdRoute =
  AuthedWorkspaceProjectsProjectIdRouteImport.update({
    id: "/$projectId",
    path: "/$projectId",
    getParentRoute: () => AuthedWorkspaceProjectsRouteRoute,
  } as any)
const AuthedWorkspaceIntegrationsCapabilityRoute =
  AuthedWorkspaceIntegrationsCapabilityRouteImport.update({
    id: "/$capability",
    path: "/$capability",
    getParentRoute: () => AuthedWorkspaceIntegrationsRouteRoute,
  } as any)
const AuthedWorkspaceFlowsFlowIdRoute =
  AuthedWorkspaceFlowsFlowIdRouteImport.update({
    id: "/$flowId",
    path: "/$flowId",
    getParentRoute: () => AuthedWorkspaceFlowsRoute,
  } as any)
const AuthedWorkspaceDashboardDashboardIdRoute =
  AuthedWorkspaceDashboardDashboardIdRouteImport.update({
    id: "/workspace/dashboard_/$dashboardId",
    path: "/workspace/dashboard/$dashboardId",
    getParentRoute: () => AuthedRouteRoute,
  } as any)
const AuthedWorkspaceConnectSpaceIdRoute =
  AuthedWorkspaceConnectSpaceIdRouteImport.update({
    id: "/$spaceId",
    path: "/$spaceId",
    getParentRoute: () => AuthedWorkspaceConnectRoute,
  } as any)
const AuthedWorkspaceCanvasesCanvasIdRoute =
  AuthedWorkspaceCanvasesCanvasIdRouteImport.update({
    id: "/$canvasId",
    path: "/$canvasId",
    getParentRoute: () => AuthedWorkspaceCanvasesRoute,
  } as any)
const AuthedModalSettingsSkillsRoute =
  AuthedModalSettingsSkillsRouteImport.update({
    id: "/skills",
    path: "/skills",
    getParentRoute: () => AuthedModalSettingsRouteRoute,
  } as any)
const AuthedModalSettingsShortcutsRoute =
  AuthedModalSettingsShortcutsRouteImport.update({
    id: "/shortcuts",
    path: "/shortcuts",
    getParentRoute: () => AuthedModalSettingsRouteRoute,
  } as any)
const AuthedModalSettingsSecurityRoute =
  AuthedModalSettingsSecurityRouteImport.update({
    id: "/security",
    path: "/security",
    getParentRoute: () => AuthedModalSettingsRouteRoute,
  } as any)
const AuthedModalSettingsPrivacyRoute =
  AuthedModalSettingsPrivacyRouteImport.update({
    id: "/privacy",
    path: "/privacy",
    getParentRoute: () => AuthedModalSettingsRouteRoute,
  } as any)
const AuthedModalSettingsPresentationsRoute =
  AuthedModalSettingsPresentationsRouteImport.update({
    id: "/presentations",
    path: "/presentations",
    getParentRoute: () => AuthedModalSettingsRouteRoute,
  } as any)
const AuthedModalSettingsOrganizationRoute =
  AuthedModalSettingsOrganizationRouteImport.update({
    id: "/organization",
    path: "/organization",
    getParentRoute: () => AuthedModalSettingsRouteRoute,
  } as any)
const AuthedModalSettingsNotificationsRoute =
  AuthedModalSettingsNotificationsRouteImport.update({
    id: "/notifications",
    path: "/notifications",
    getParentRoute: () => AuthedModalSettingsRouteRoute,
  } as any)
const AuthedModalSettingsModesRoute =
  AuthedModalSettingsModesRouteImport.update({
    id: "/modes",
    path: "/modes",
    getParentRoute: () => AuthedModalSettingsRouteRoute,
  } as any)
const AuthedModalSettingsMemoryRoute =
  AuthedModalSettingsMemoryRouteImport.update({
    id: "/memory",
    path: "/memory",
    getParentRoute: () => AuthedModalSettingsRouteRoute,
  } as any)
const AuthedModalSettingsMarpTemplatesRoute =
  AuthedModalSettingsMarpTemplatesRouteImport.update({
    id: "/marp-templates",
    path: "/marp-templates",
    getParentRoute: () => AuthedModalSettingsRouteRoute,
  } as any)
const AuthedModalSettingsHelpRoute = AuthedModalSettingsHelpRouteImport.update({
  id: "/help",
  path: "/help",
  getParentRoute: () => AuthedModalSettingsRouteRoute,
} as any)
const AuthedModalSettingsChangelogRoute =
  AuthedModalSettingsChangelogRouteImport.update({
    id: "/changelog",
    path: "/changelog",
    getParentRoute: () => AuthedModalSettingsRouteRoute,
  } as any)
const AuthedModalSettingsBrandKitsRoute =
  AuthedModalSettingsBrandKitsRouteImport.update({
    id: "/brand-kits",
    path: "/brand-kits",
    getParentRoute: () => AuthedModalSettingsRouteRoute,
  } as any)
const AuthedModalSettingsBillingRoute =
  AuthedModalSettingsBillingRouteImport.update({
    id: "/billing",
    path: "/billing",
    getParentRoute: () => AuthedModalSettingsRouteRoute,
  } as any)
const AuthedModalIntegrationsCapabilityRoute =
  AuthedModalIntegrationsCapabilityRouteImport.update({
    id: "/$capability",
    path: "/$capability",
    getParentRoute: () => AuthedModalIntegrationsRouteRoute,
  } as any)
const AuthedModalEngineGetStartedRoute =
  AuthedModalEngineGetStartedRouteImport.update({
    id: "/engine/get-started",
    path: "/engine/get-started",
    getParentRoute: () => AuthedModalRouteRoute,
  } as any)
const AuthedModalConsoleUsageRoute = AuthedModalConsoleUsageRouteImport.update({
  id: "/usage",
  path: "/usage",
  getParentRoute: () => AuthedModalConsoleRouteRoute,
} as any)
const AuthedModalConsoleTracesRoute =
  AuthedModalConsoleTracesRouteImport.update({
    id: "/traces",
    path: "/traces",
    getParentRoute: () => AuthedModalConsoleRouteRoute,
  } as any)
const AuthedModalConsoleSchemaRoute =
  AuthedModalConsoleSchemaRouteImport.update({
    id: "/schema",
    path: "/schema",
    getParentRoute: () => AuthedModalConsoleRouteRoute,
  } as any)
const AuthedModalConsolePlaygroundRoute =
  AuthedModalConsolePlaygroundRouteImport.update({
    id: "/playground",
    path: "/playground",
    getParentRoute: () => AuthedModalConsoleRouteRoute,
  } as any)
const AuthedModalConsoleModelsRoute =
  AuthedModalConsoleModelsRouteImport.update({
    id: "/models",
    path: "/models",
    getParentRoute: () => AuthedModalConsoleRouteRoute,
  } as any)
const AuthedModalConsoleMembersRoute =
  AuthedModalConsoleMembersRouteImport.update({
    id: "/members",
    path: "/members",
    getParentRoute: () => AuthedModalConsoleRouteRoute,
  } as any)
const AuthedModalConsoleLimitsRoute =
  AuthedModalConsoleLimitsRouteImport.update({
    id: "/limits",
    path: "/limits",
    getParentRoute: () => AuthedModalConsoleRouteRoute,
  } as any)
const AuthedModalConsoleGetStartedRoute =
  AuthedModalConsoleGetStartedRouteImport.update({
    id: "/get-started",
    path: "/get-started",
    getParentRoute: () => AuthedModalConsoleRouteRoute,
  } as any)
const AuthedModalConsoleEmbeddedIdentityRoute =
  AuthedModalConsoleEmbeddedIdentityRouteImport.update({
    id: "/embedded-identity",
    path: "/embedded-identity",
    getParentRoute: () => AuthedModalConsoleRouteRoute,
  } as any)
const AuthedModalConsoleDocumentsRoute =
  AuthedModalConsoleDocumentsRouteImport.update({
    id: "/documents",
    path: "/documents",
    getParentRoute: () => AuthedModalConsoleRouteRoute,
  } as any)
const AuthedModalConsoleDocsRoute = AuthedModalConsoleDocsRouteImport.update({
  id: "/docs",
  path: "/docs",
  getParentRoute: () => AuthedModalConsoleRouteRoute,
} as any)
const AuthedModalConsoleDevelopersRoute =
  AuthedModalConsoleDevelopersRouteImport.update({
    id: "/developers",
    path: "/developers",
    getParentRoute: () => AuthedModalConsoleRouteRoute,
  } as any)
const AuthedModalConsoleBillingRoute =
  AuthedModalConsoleBillingRouteImport.update({
    id: "/billing",
    path: "/billing",
    getParentRoute: () => AuthedModalConsoleRouteRoute,
  } as any)
const AuthedModalConsoleAppsRoute = AuthedModalConsoleAppsRouteImport.update({
  id: "/apps",
  path: "/apps",
  getParentRoute: () => AuthedModalConsoleRouteRoute,
} as any)
const AuthedModalConsoleActionsRoute =
  AuthedModalConsoleActionsRouteImport.update({
    id: "/actions",
    path: "/actions",
    getParentRoute: () => AuthedModalConsoleRouteRoute,
  } as any)
const AuthedModalConsoleAccountsRoute =
  AuthedModalConsoleAccountsRouteImport.update({
    id: "/accounts",
    path: "/accounts",
    getParentRoute: () => AuthedModalConsoleRouteRoute,
  } as any)
const AuthedModalConsoleAccessRoute =
  AuthedModalConsoleAccessRouteImport.update({
    id: "/access",
    path: "/access",
    getParentRoute: () => AuthedModalConsoleRouteRoute,
  } as any)
const AuthedModalAdminRevenueRoute = AuthedModalAdminRevenueRouteImport.update({
  id: "/revenue",
  path: "/revenue",
  getParentRoute: () => AuthedModalAdminRouteRoute,
} as any)
const AuthedModalAdminQualityRoute = AuthedModalAdminQualityRouteImport.update({
  id: "/quality",
  path: "/quality",
  getParentRoute: () => AuthedModalAdminRouteRoute,
} as any)
const AuthedModalAdminPricingMarkupRoute =
  AuthedModalAdminPricingMarkupRouteImport.update({
    id: "/pricing-markup",
    path: "/pricing-markup",
    getParentRoute: () => AuthedModalAdminRouteRoute,
  } as any)
const AuthedModalAdminPreventiviRoute =
  AuthedModalAdminPreventiviRouteImport.update({
    id: "/preventivi",
    path: "/preventivi",
    getParentRoute: () => AuthedModalAdminRouteRoute,
  } as any)
const AuthedModalAdminPresentazioniRoute =
  AuthedModalAdminPresentazioniRouteImport.update({
    id: "/presentazioni",
    path: "/presentazioni",
    getParentRoute: () => AuthedModalAdminRouteRoute,
  } as any)
const AuthedModalAdminPlatformSettingsRoute =
  AuthedModalAdminPlatformSettingsRouteImport.update({
    id: "/platform-settings",
    path: "/platform-settings",
    getParentRoute: () => AuthedModalAdminRouteRoute,
  } as any)
const AuthedModalAdminHypermemRoute =
  AuthedModalAdminHypermemRouteImport.update({
    id: "/hypermem",
    path: "/hypermem",
    getParentRoute: () => AuthedModalAdminRouteRoute,
  } as any)
const AuthedModalAdminHealthRoute = AuthedModalAdminHealthRouteImport.update({
  id: "/health",
  path: "/health",
  getParentRoute: () => AuthedModalAdminRouteRoute,
} as any)
const AuthedModalAdminEngagementRoute =
  AuthedModalAdminEngagementRouteImport.update({
    id: "/engagement",
    path: "/engagement",
    getParentRoute: () => AuthedModalAdminRouteRoute,
  } as any)
const AuthedModalAdminDemoInvitiRoute =
  AuthedModalAdminDemoInvitiRouteImport.update({
    id: "/demo-inviti",
    path: "/demo-inviti",
    getParentRoute: () => AuthedModalAdminRouteRoute,
  } as any)
const AuthedModalAdminCostTrackingRoute =
  AuthedModalAdminCostTrackingRouteImport.update({
    id: "/cost-tracking",
    path: "/cost-tracking",
    getParentRoute: () => AuthedModalAdminRouteRoute,
  } as any)
const AuthedModalAdminCanvasRoute = AuthedModalAdminCanvasRouteImport.update({
  id: "/canvas",
  path: "/canvas",
  getParentRoute: () => AuthedModalAdminRouteRoute,
} as any)
const AuthedModalAdminBillingRoute = AuthedModalAdminBillingRouteImport.update({
  id: "/billing",
  path: "/billing",
  getParentRoute: () => AuthedModalAdminRouteRoute,
} as any)
const AuthedModalAdminAutomationRoute =
  AuthedModalAdminAutomationRouteImport.update({
    id: "/automation",
    path: "/automation",
    getParentRoute: () => AuthedModalAdminRouteRoute,
  } as any)
const AuthedModalConsoleKeysIndexRoute =
  AuthedModalConsoleKeysIndexRouteImport.update({
    id: "/keys/",
    path: "/keys/",
    getParentRoute: () => AuthedModalConsoleRouteRoute,
  } as any)
const AuthedModalConsoleFlowsIndexRoute =
  AuthedModalConsoleFlowsIndexRouteImport.update({
    id: "/flows/",
    path: "/flows/",
    getParentRoute: () => AuthedModalConsoleRouteRoute,
  } as any)
const AuthedModalConsoleConnectorsIndexRoute =
  AuthedModalConsoleConnectorsIndexRouteImport.update({
    id: "/connectors/",
    path: "/connectors/",
    getParentRoute: () => AuthedModalConsoleRouteRoute,
  } as any)
const AuthedModalAdminUsersIndexRoute =
  AuthedModalAdminUsersIndexRouteImport.update({
    id: "/users/",
    path: "/users/",
    getParentRoute: () => AuthedModalAdminRouteRoute,
  } as any)
const AuthedModalAdminOrgsIndexRoute =
  AuthedModalAdminOrgsIndexRouteImport.update({
    id: "/orgs/",
    path: "/orgs/",
    getParentRoute: () => AuthedModalAdminRouteRoute,
  } as any)
const AuthedWorkspaceTemplatesEditSlugRoute =
  AuthedWorkspaceTemplatesEditSlugRouteImport.update({
    id: "/edit/$slug",
    path: "/edit/$slug",
    getParentRoute: () => AuthedWorkspaceTemplatesRouteRoute,
  } as any)
const AuthedWorkspaceFlowsFlowIdRunRoute =
  AuthedWorkspaceFlowsFlowIdRunRouteImport.update({
    id: "/$flowId_/run",
    path: "/$flowId/run",
    getParentRoute: () => AuthedWorkspaceFlowsRoute,
  } as any)
const AuthedModalConsoleKeysKeyIdRoute =
  AuthedModalConsoleKeysKeyIdRouteImport.update({
    id: "/keys/$keyId",
    path: "/keys/$keyId",
    getParentRoute: () => AuthedModalConsoleRouteRoute,
  } as any)
const AuthedModalConsoleFlowsFlowIdRoute =
  AuthedModalConsoleFlowsFlowIdRouteImport.update({
    id: "/flows/$flowId",
    path: "/flows/$flowId",
    getParentRoute: () => AuthedModalConsoleRouteRoute,
  } as any)
const AuthedModalConsoleDocumentAccessDocumentIdRoute =
  AuthedModalConsoleDocumentAccessDocumentIdRouteImport.update({
    id: "/document-access/$documentId",
    path: "/document-access/$documentId",
    getParentRoute: () => AuthedModalConsoleRouteRoute,
  } as any)
const AuthedModalConsoleConnectorsConnectionIdRoute =
  AuthedModalConsoleConnectorsConnectionIdRouteImport.update({
    id: "/connectors/$connectionId",
    path: "/connectors/$connectionId",
    getParentRoute: () => AuthedModalConsoleRouteRoute,
  } as any)
const AuthedModalConsoleConnectionAccessConnectionIdRoute =
  AuthedModalConsoleConnectionAccessConnectionIdRouteImport.update({
    id: "/connection-access/$connectionId",
    path: "/connection-access/$connectionId",
    getParentRoute: () => AuthedModalConsoleRouteRoute,
  } as any)
const AuthedModalAdminUsersUserIdRoute =
  AuthedModalAdminUsersUserIdRouteImport.update({
    id: "/users/$userId",
    path: "/users/$userId",
    getParentRoute: () => AuthedModalAdminRouteRoute,
  } as any)
const AuthedModalAdminOrgsOrgIdRoute =
  AuthedModalAdminOrgsOrgIdRouteImport.update({
    id: "/orgs/$orgId",
    path: "/orgs/$orgId",
    getParentRoute: () => AuthedModalAdminRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  "/": typeof AuthedIndexRoute
  "/login": typeof LoginRoute
  "/auth/callback": typeof AuthCallbackRoute
  "/forms/$flowId": typeof FormsFlowIdRoute
  "/admin": typeof AuthedModalAdminRouteRouteWithChildren
  "/console": typeof AuthedModalConsoleRouteRouteWithChildren
  "/integrations": typeof AuthedModalIntegrationsRouteRouteWithChildren
  "/settings": typeof AuthedModalSettingsRouteRouteWithChildren
  "/workspace/integrations": typeof AuthedWorkspaceIntegrationsRouteRouteWithChildren
  "/workspace/projects": typeof AuthedWorkspaceProjectsRouteRouteWithChildren
  "/workspace/reports": typeof AuthedWorkspaceReportsRouteRouteWithChildren
  "/workspace/templates": typeof AuthedWorkspaceTemplatesRouteRouteWithChildren
  "/workspace/automations": typeof AuthedWorkspaceAutomationsRoute
  "/workspace/calendar": typeof AuthedWorkspaceCalendarRoute
  "/workspace/canvases": typeof AuthedWorkspaceCanvasesRouteWithChildren
  "/workspace/clean-control": typeof AuthedWorkspaceCleanControlRoute
  "/workspace/connect": typeof AuthedWorkspaceConnectRouteWithChildren
  "/workspace/conversations": typeof AuthedWorkspaceConversationsRoute
  "/workspace/dashboard": typeof AuthedWorkspaceDashboardRoute
  "/workspace/documents": typeof AuthedWorkspaceDocumentsRoute
  "/workspace/dxf-library": typeof AuthedWorkspaceDxfLibraryRoute
  "/workspace/finance": typeof AuthedWorkspaceFinanceRoute
  "/workspace/flows": typeof AuthedWorkspaceFlowsRouteWithChildren
  "/workspace/sales": typeof AuthedWorkspaceSalesRoute
  "/workspace/shares": typeof AuthedWorkspaceSharesRoute
  "/workspace/technical": typeof AuthedWorkspaceTechnicalRoute
  "/workspace/work": typeof AuthedWorkspaceWorkRoute
  "/connect/chatbot/$publicToken": typeof ConnectChatbotPublicTokenRoute
  "/connect/invite/$token": typeof ConnectInviteTokenRoute
  "/connect/space/$spaceId": typeof ConnectSpaceSpaceIdRoute
  "/public/voice-report/$token": typeof PublicVoiceReportTokenRoute
  "/workspace/": typeof AuthedWorkspaceIndexRoute
  "/admin/automation": typeof AuthedModalAdminAutomationRoute
  "/admin/billing": typeof AuthedModalAdminBillingRoute
  "/admin/canvas": typeof AuthedModalAdminCanvasRoute
  "/admin/cost-tracking": typeof AuthedModalAdminCostTrackingRoute
  "/admin/demo-inviti": typeof AuthedModalAdminDemoInvitiRoute
  "/admin/engagement": typeof AuthedModalAdminEngagementRoute
  "/admin/health": typeof AuthedModalAdminHealthRoute
  "/admin/hypermem": typeof AuthedModalAdminHypermemRoute
  "/admin/platform-settings": typeof AuthedModalAdminPlatformSettingsRoute
  "/admin/presentazioni": typeof AuthedModalAdminPresentazioniRoute
  "/admin/preventivi": typeof AuthedModalAdminPreventiviRoute
  "/admin/pricing-markup": typeof AuthedModalAdminPricingMarkupRoute
  "/admin/quality": typeof AuthedModalAdminQualityRoute
  "/admin/revenue": typeof AuthedModalAdminRevenueRoute
  "/console/access": typeof AuthedModalConsoleAccessRoute
  "/console/accounts": typeof AuthedModalConsoleAccountsRoute
  "/console/actions": typeof AuthedModalConsoleActionsRoute
  "/console/apps": typeof AuthedModalConsoleAppsRoute
  "/console/billing": typeof AuthedModalConsoleBillingRoute
  "/console/developers": typeof AuthedModalConsoleDevelopersRoute
  "/console/docs": typeof AuthedModalConsoleDocsRoute
  "/console/documents": typeof AuthedModalConsoleDocumentsRoute
  "/console/embedded-identity": typeof AuthedModalConsoleEmbeddedIdentityRoute
  "/console/get-started": typeof AuthedModalConsoleGetStartedRoute
  "/console/limits": typeof AuthedModalConsoleLimitsRoute
  "/console/members": typeof AuthedModalConsoleMembersRoute
  "/console/models": typeof AuthedModalConsoleModelsRoute
  "/console/playground": typeof AuthedModalConsolePlaygroundRoute
  "/console/schema": typeof AuthedModalConsoleSchemaRoute
  "/console/traces": typeof AuthedModalConsoleTracesRoute
  "/console/usage": typeof AuthedModalConsoleUsageRoute
  "/engine/get-started": typeof AuthedModalEngineGetStartedRoute
  "/integrations/$capability": typeof AuthedModalIntegrationsCapabilityRoute
  "/settings/billing": typeof AuthedModalSettingsBillingRoute
  "/settings/brand-kits": typeof AuthedModalSettingsBrandKitsRoute
  "/settings/changelog": typeof AuthedModalSettingsChangelogRoute
  "/settings/help": typeof AuthedModalSettingsHelpRoute
  "/settings/marp-templates": typeof AuthedModalSettingsMarpTemplatesRoute
  "/settings/memory": typeof AuthedModalSettingsMemoryRoute
  "/settings/modes": typeof AuthedModalSettingsModesRoute
  "/settings/notifications": typeof AuthedModalSettingsNotificationsRoute
  "/settings/organization": typeof AuthedModalSettingsOrganizationRoute
  "/settings/presentations": typeof AuthedModalSettingsPresentationsRoute
  "/settings/privacy": typeof AuthedModalSettingsPrivacyRoute
  "/settings/security": typeof AuthedModalSettingsSecurityRoute
  "/settings/shortcuts": typeof AuthedModalSettingsShortcutsRoute
  "/settings/skills": typeof AuthedModalSettingsSkillsRoute
  "/workspace/canvases/$canvasId": typeof AuthedWorkspaceCanvasesCanvasIdRoute
  "/workspace/connect/$spaceId": typeof AuthedWorkspaceConnectSpaceIdRoute
  "/workspace/dashboard/$dashboardId": typeof AuthedWorkspaceDashboardDashboardIdRoute
  "/workspace/flows/$flowId": typeof AuthedWorkspaceFlowsFlowIdRoute
  "/workspace/integrations/$capability": typeof AuthedWorkspaceIntegrationsCapabilityRoute
  "/workspace/projects/$projectId": typeof AuthedWorkspaceProjectsProjectIdRoute
  "/workspace/reports/$reportId": typeof AuthedWorkspaceReportsReportIdRoute
  "/workspace/templates/$kind": typeof AuthedWorkspaceTemplatesKindRoute
  "/admin/": typeof AuthedModalAdminIndexRoute
  "/console/": typeof AuthedModalConsoleIndexRoute
  "/integrations/": typeof AuthedModalIntegrationsIndexRoute
  "/settings/": typeof AuthedModalSettingsIndexRoute
  "/workspace/connect/": typeof AuthedWorkspaceConnectIndexRoute
  "/workspace/flows/": typeof AuthedWorkspaceFlowsIndexRoute
  "/workspace/integrations/": typeof AuthedWorkspaceIntegrationsIndexRoute
  "/workspace/projects/": typeof AuthedWorkspaceProjectsIndexRoute
  "/workspace/reports/": typeof AuthedWorkspaceReportsIndexRoute
  "/workspace/templates/": typeof AuthedWorkspaceTemplatesIndexRoute
  "/admin/orgs/$orgId": typeof AuthedModalAdminOrgsOrgIdRoute
  "/admin/users/$userId": typeof AuthedModalAdminUsersUserIdRoute
  "/console/connection-access/$connectionId": typeof AuthedModalConsoleConnectionAccessConnectionIdRoute
  "/console/connectors/$connectionId": typeof AuthedModalConsoleConnectorsConnectionIdRoute
  "/console/document-access/$documentId": typeof AuthedModalConsoleDocumentAccessDocumentIdRoute
  "/console/flows/$flowId": typeof AuthedModalConsoleFlowsFlowIdRoute
  "/console/keys/$keyId": typeof AuthedModalConsoleKeysKeyIdRoute
  "/workspace/flows/$flowId/run": typeof AuthedWorkspaceFlowsFlowIdRunRoute
  "/workspace/templates/edit/$slug": typeof AuthedWorkspaceTemplatesEditSlugRoute
  "/admin/orgs/": typeof AuthedModalAdminOrgsIndexRoute
  "/admin/users/": typeof AuthedModalAdminUsersIndexRoute
  "/console/connectors/": typeof AuthedModalConsoleConnectorsIndexRoute
  "/console/flows/": typeof AuthedModalConsoleFlowsIndexRoute
  "/console/keys/": typeof AuthedModalConsoleKeysIndexRoute
}
export interface FileRoutesByTo {
  "/login": typeof LoginRoute
  "/": typeof AuthedIndexRoute
  "/auth/callback": typeof AuthCallbackRoute
  "/forms/$flowId": typeof FormsFlowIdRoute
  "/workspace/automations": typeof AuthedWorkspaceAutomationsRoute
  "/workspace/calendar": typeof AuthedWorkspaceCalendarRoute
  "/workspace/canvases": typeof AuthedWorkspaceCanvasesRouteWithChildren
  "/workspace/clean-control": typeof AuthedWorkspaceCleanControlRoute
  "/workspace/conversations": typeof AuthedWorkspaceConversationsRoute
  "/workspace/dashboard": typeof AuthedWorkspaceDashboardRoute
  "/workspace/documents": typeof AuthedWorkspaceDocumentsRoute
  "/workspace/dxf-library": typeof AuthedWorkspaceDxfLibraryRoute
  "/workspace/finance": typeof AuthedWorkspaceFinanceRoute
  "/workspace/sales": typeof AuthedWorkspaceSalesRoute
  "/workspace/shares": typeof AuthedWorkspaceSharesRoute
  "/workspace/technical": typeof AuthedWorkspaceTechnicalRoute
  "/workspace/work": typeof AuthedWorkspaceWorkRoute
  "/connect/chatbot/$publicToken": typeof ConnectChatbotPublicTokenRoute
  "/connect/invite/$token": typeof ConnectInviteTokenRoute
  "/connect/space/$spaceId": typeof ConnectSpaceSpaceIdRoute
  "/public/voice-report/$token": typeof PublicVoiceReportTokenRoute
  "/workspace": typeof AuthedWorkspaceIndexRoute
  "/admin/automation": typeof AuthedModalAdminAutomationRoute
  "/admin/billing": typeof AuthedModalAdminBillingRoute
  "/admin/canvas": typeof AuthedModalAdminCanvasRoute
  "/admin/cost-tracking": typeof AuthedModalAdminCostTrackingRoute
  "/admin/demo-inviti": typeof AuthedModalAdminDemoInvitiRoute
  "/admin/engagement": typeof AuthedModalAdminEngagementRoute
  "/admin/health": typeof AuthedModalAdminHealthRoute
  "/admin/hypermem": typeof AuthedModalAdminHypermemRoute
  "/admin/platform-settings": typeof AuthedModalAdminPlatformSettingsRoute
  "/admin/presentazioni": typeof AuthedModalAdminPresentazioniRoute
  "/admin/preventivi": typeof AuthedModalAdminPreventiviRoute
  "/admin/pricing-markup": typeof AuthedModalAdminPricingMarkupRoute
  "/admin/quality": typeof AuthedModalAdminQualityRoute
  "/admin/revenue": typeof AuthedModalAdminRevenueRoute
  "/console/access": typeof AuthedModalConsoleAccessRoute
  "/console/accounts": typeof AuthedModalConsoleAccountsRoute
  "/console/actions": typeof AuthedModalConsoleActionsRoute
  "/console/apps": typeof AuthedModalConsoleAppsRoute
  "/console/billing": typeof AuthedModalConsoleBillingRoute
  "/console/developers": typeof AuthedModalConsoleDevelopersRoute
  "/console/docs": typeof AuthedModalConsoleDocsRoute
  "/console/documents": typeof AuthedModalConsoleDocumentsRoute
  "/console/embedded-identity": typeof AuthedModalConsoleEmbeddedIdentityRoute
  "/console/get-started": typeof AuthedModalConsoleGetStartedRoute
  "/console/limits": typeof AuthedModalConsoleLimitsRoute
  "/console/members": typeof AuthedModalConsoleMembersRoute
  "/console/models": typeof AuthedModalConsoleModelsRoute
  "/console/playground": typeof AuthedModalConsolePlaygroundRoute
  "/console/schema": typeof AuthedModalConsoleSchemaRoute
  "/console/traces": typeof AuthedModalConsoleTracesRoute
  "/console/usage": typeof AuthedModalConsoleUsageRoute
  "/engine/get-started": typeof AuthedModalEngineGetStartedRoute
  "/integrations/$capability": typeof AuthedModalIntegrationsCapabilityRoute
  "/settings/billing": typeof AuthedModalSettingsBillingRoute
  "/settings/brand-kits": typeof AuthedModalSettingsBrandKitsRoute
  "/settings/changelog": typeof AuthedModalSettingsChangelogRoute
  "/settings/help": typeof AuthedModalSettingsHelpRoute
  "/settings/marp-templates": typeof AuthedModalSettingsMarpTemplatesRoute
  "/settings/memory": typeof AuthedModalSettingsMemoryRoute
  "/settings/modes": typeof AuthedModalSettingsModesRoute
  "/settings/notifications": typeof AuthedModalSettingsNotificationsRoute
  "/settings/organization": typeof AuthedModalSettingsOrganizationRoute
  "/settings/presentations": typeof AuthedModalSettingsPresentationsRoute
  "/settings/privacy": typeof AuthedModalSettingsPrivacyRoute
  "/settings/security": typeof AuthedModalSettingsSecurityRoute
  "/settings/shortcuts": typeof AuthedModalSettingsShortcutsRoute
  "/settings/skills": typeof AuthedModalSettingsSkillsRoute
  "/workspace/canvases/$canvasId": typeof AuthedWorkspaceCanvasesCanvasIdRoute
  "/workspace/connect/$spaceId": typeof AuthedWorkspaceConnectSpaceIdRoute
  "/workspace/dashboard/$dashboardId": typeof AuthedWorkspaceDashboardDashboardIdRoute
  "/workspace/flows/$flowId": typeof AuthedWorkspaceFlowsFlowIdRoute
  "/workspace/integrations/$capability": typeof AuthedWorkspaceIntegrationsCapabilityRoute
  "/workspace/projects/$projectId": typeof AuthedWorkspaceProjectsProjectIdRoute
  "/workspace/reports/$reportId": typeof AuthedWorkspaceReportsReportIdRoute
  "/workspace/templates/$kind": typeof AuthedWorkspaceTemplatesKindRoute
  "/admin": typeof AuthedModalAdminIndexRoute
  "/console": typeof AuthedModalConsoleIndexRoute
  "/integrations": typeof AuthedModalIntegrationsIndexRoute
  "/settings": typeof AuthedModalSettingsIndexRoute
  "/workspace/connect": typeof AuthedWorkspaceConnectIndexRoute
  "/workspace/flows": typeof AuthedWorkspaceFlowsIndexRoute
  "/workspace/integrations": typeof AuthedWorkspaceIntegrationsIndexRoute
  "/workspace/projects": typeof AuthedWorkspaceProjectsIndexRoute
  "/workspace/reports": typeof AuthedWorkspaceReportsIndexRoute
  "/workspace/templates": typeof AuthedWorkspaceTemplatesIndexRoute
  "/admin/orgs/$orgId": typeof AuthedModalAdminOrgsOrgIdRoute
  "/admin/users/$userId": typeof AuthedModalAdminUsersUserIdRoute
  "/console/connection-access/$connectionId": typeof AuthedModalConsoleConnectionAccessConnectionIdRoute
  "/console/connectors/$connectionId": typeof AuthedModalConsoleConnectorsConnectionIdRoute
  "/console/document-access/$documentId": typeof AuthedModalConsoleDocumentAccessDocumentIdRoute
  "/console/flows/$flowId": typeof AuthedModalConsoleFlowsFlowIdRoute
  "/console/keys/$keyId": typeof AuthedModalConsoleKeysKeyIdRoute
  "/workspace/flows/$flowId/run": typeof AuthedWorkspaceFlowsFlowIdRunRoute
  "/workspace/templates/edit/$slug": typeof AuthedWorkspaceTemplatesEditSlugRoute
  "/admin/orgs": typeof AuthedModalAdminOrgsIndexRoute
  "/admin/users": typeof AuthedModalAdminUsersIndexRoute
  "/console/connectors": typeof AuthedModalConsoleConnectorsIndexRoute
  "/console/flows": typeof AuthedModalConsoleFlowsIndexRoute
  "/console/keys": typeof AuthedModalConsoleKeysIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/_authed": typeof AuthedRouteRouteWithChildren
  "/login": typeof LoginRoute
  "/_authed/_modal": typeof AuthedModalRouteRouteWithChildren
  "/auth/callback": typeof AuthCallbackRoute
  "/forms/$flowId": typeof FormsFlowIdRoute
  "/_authed/": typeof AuthedIndexRoute
  "/_authed/_modal/admin": typeof AuthedModalAdminRouteRouteWithChildren
  "/_authed/_modal/console": typeof AuthedModalConsoleRouteRouteWithChildren
  "/_authed/_modal/integrations": typeof AuthedModalIntegrationsRouteRouteWithChildren
  "/_authed/_modal/settings": typeof AuthedModalSettingsRouteRouteWithChildren
  "/_authed/workspace/integrations": typeof AuthedWorkspaceIntegrationsRouteRouteWithChildren
  "/_authed/workspace/projects": typeof AuthedWorkspaceProjectsRouteRouteWithChildren
  "/_authed/workspace/reports": typeof AuthedWorkspaceReportsRouteRouteWithChildren
  "/_authed/workspace/templates": typeof AuthedWorkspaceTemplatesRouteRouteWithChildren
  "/_authed/workspace/automations": typeof AuthedWorkspaceAutomationsRoute
  "/_authed/workspace/calendar": typeof AuthedWorkspaceCalendarRoute
  "/_authed/workspace/canvases": typeof AuthedWorkspaceCanvasesRouteWithChildren
  "/_authed/workspace/clean-control": typeof AuthedWorkspaceCleanControlRoute
  "/_authed/workspace/connect": typeof AuthedWorkspaceConnectRouteWithChildren
  "/_authed/workspace/conversations": typeof AuthedWorkspaceConversationsRoute
  "/_authed/workspace/dashboard": typeof AuthedWorkspaceDashboardRoute
  "/_authed/workspace/documents": typeof AuthedWorkspaceDocumentsRoute
  "/_authed/workspace/dxf-library": typeof AuthedWorkspaceDxfLibraryRoute
  "/_authed/workspace/finance": typeof AuthedWorkspaceFinanceRoute
  "/_authed/workspace/flows": typeof AuthedWorkspaceFlowsRouteWithChildren
  "/_authed/workspace/sales": typeof AuthedWorkspaceSalesRoute
  "/_authed/workspace/shares": typeof AuthedWorkspaceSharesRoute
  "/_authed/workspace/technical": typeof AuthedWorkspaceTechnicalRoute
  "/_authed/workspace/work": typeof AuthedWorkspaceWorkRoute
  "/connect/chatbot/$publicToken": typeof ConnectChatbotPublicTokenRoute
  "/connect/invite/$token": typeof ConnectInviteTokenRoute
  "/connect/space/$spaceId": typeof ConnectSpaceSpaceIdRoute
  "/public/voice-report/$token": typeof PublicVoiceReportTokenRoute
  "/_authed/workspace/": typeof AuthedWorkspaceIndexRoute
  "/_authed/_modal/admin/automation": typeof AuthedModalAdminAutomationRoute
  "/_authed/_modal/admin/billing": typeof AuthedModalAdminBillingRoute
  "/_authed/_modal/admin/canvas": typeof AuthedModalAdminCanvasRoute
  "/_authed/_modal/admin/cost-tracking": typeof AuthedModalAdminCostTrackingRoute
  "/_authed/_modal/admin/demo-inviti": typeof AuthedModalAdminDemoInvitiRoute
  "/_authed/_modal/admin/engagement": typeof AuthedModalAdminEngagementRoute
  "/_authed/_modal/admin/health": typeof AuthedModalAdminHealthRoute
  "/_authed/_modal/admin/hypermem": typeof AuthedModalAdminHypermemRoute
  "/_authed/_modal/admin/platform-settings": typeof AuthedModalAdminPlatformSettingsRoute
  "/_authed/_modal/admin/presentazioni": typeof AuthedModalAdminPresentazioniRoute
  "/_authed/_modal/admin/preventivi": typeof AuthedModalAdminPreventiviRoute
  "/_authed/_modal/admin/pricing-markup": typeof AuthedModalAdminPricingMarkupRoute
  "/_authed/_modal/admin/quality": typeof AuthedModalAdminQualityRoute
  "/_authed/_modal/admin/revenue": typeof AuthedModalAdminRevenueRoute
  "/_authed/_modal/console/access": typeof AuthedModalConsoleAccessRoute
  "/_authed/_modal/console/accounts": typeof AuthedModalConsoleAccountsRoute
  "/_authed/_modal/console/actions": typeof AuthedModalConsoleActionsRoute
  "/_authed/_modal/console/apps": typeof AuthedModalConsoleAppsRoute
  "/_authed/_modal/console/billing": typeof AuthedModalConsoleBillingRoute
  "/_authed/_modal/console/developers": typeof AuthedModalConsoleDevelopersRoute
  "/_authed/_modal/console/docs": typeof AuthedModalConsoleDocsRoute
  "/_authed/_modal/console/documents": typeof AuthedModalConsoleDocumentsRoute
  "/_authed/_modal/console/embedded-identity": typeof AuthedModalConsoleEmbeddedIdentityRoute
  "/_authed/_modal/console/get-started": typeof AuthedModalConsoleGetStartedRoute
  "/_authed/_modal/console/limits": typeof AuthedModalConsoleLimitsRoute
  "/_authed/_modal/console/members": typeof AuthedModalConsoleMembersRoute
  "/_authed/_modal/console/models": typeof AuthedModalConsoleModelsRoute
  "/_authed/_modal/console/playground": typeof AuthedModalConsolePlaygroundRoute
  "/_authed/_modal/console/schema": typeof AuthedModalConsoleSchemaRoute
  "/_authed/_modal/console/traces": typeof AuthedModalConsoleTracesRoute
  "/_authed/_modal/console/usage": typeof AuthedModalConsoleUsageRoute
  "/_authed/_modal/engine/get-started": typeof AuthedModalEngineGetStartedRoute
  "/_authed/_modal/integrations/$capability": typeof AuthedModalIntegrationsCapabilityRoute
  "/_authed/_modal/settings/billing": typeof AuthedModalSettingsBillingRoute
  "/_authed/_modal/settings/brand-kits": typeof AuthedModalSettingsBrandKitsRoute
  "/_authed/_modal/settings/changelog": typeof AuthedModalSettingsChangelogRoute
  "/_authed/_modal/settings/help": typeof AuthedModalSettingsHelpRoute
  "/_authed/_modal/settings/marp-templates": typeof AuthedModalSettingsMarpTemplatesRoute
  "/_authed/_modal/settings/memory": typeof AuthedModalSettingsMemoryRoute
  "/_authed/_modal/settings/modes": typeof AuthedModalSettingsModesRoute
  "/_authed/_modal/settings/notifications": typeof AuthedModalSettingsNotificationsRoute
  "/_authed/_modal/settings/organization": typeof AuthedModalSettingsOrganizationRoute
  "/_authed/_modal/settings/presentations": typeof AuthedModalSettingsPresentationsRoute
  "/_authed/_modal/settings/privacy": typeof AuthedModalSettingsPrivacyRoute
  "/_authed/_modal/settings/security": typeof AuthedModalSettingsSecurityRoute
  "/_authed/_modal/settings/shortcuts": typeof AuthedModalSettingsShortcutsRoute
  "/_authed/_modal/settings/skills": typeof AuthedModalSettingsSkillsRoute
  "/_authed/workspace/canvases/$canvasId": typeof AuthedWorkspaceCanvasesCanvasIdRoute
  "/_authed/workspace/connect/$spaceId": typeof AuthedWorkspaceConnectSpaceIdRoute
  "/_authed/workspace/dashboard_/$dashboardId": typeof AuthedWorkspaceDashboardDashboardIdRoute
  "/_authed/workspace/flows/$flowId": typeof AuthedWorkspaceFlowsFlowIdRoute
  "/_authed/workspace/integrations/$capability": typeof AuthedWorkspaceIntegrationsCapabilityRoute
  "/_authed/workspace/projects/$projectId": typeof AuthedWorkspaceProjectsProjectIdRoute
  "/_authed/workspace/reports/$reportId": typeof AuthedWorkspaceReportsReportIdRoute
  "/_authed/workspace/templates/$kind": typeof AuthedWorkspaceTemplatesKindRoute
  "/_authed/_modal/admin/": typeof AuthedModalAdminIndexRoute
  "/_authed/_modal/console/": typeof AuthedModalConsoleIndexRoute
  "/_authed/_modal/integrations/": typeof AuthedModalIntegrationsIndexRoute
  "/_authed/_modal/settings/": typeof AuthedModalSettingsIndexRoute
  "/_authed/workspace/connect/": typeof AuthedWorkspaceConnectIndexRoute
  "/_authed/workspace/flows/": typeof AuthedWorkspaceFlowsIndexRoute
  "/_authed/workspace/integrations/": typeof AuthedWorkspaceIntegrationsIndexRoute
  "/_authed/workspace/projects/": typeof AuthedWorkspaceProjectsIndexRoute
  "/_authed/workspace/reports/": typeof AuthedWorkspaceReportsIndexRoute
  "/_authed/workspace/templates/": typeof AuthedWorkspaceTemplatesIndexRoute
  "/_authed/_modal/admin/orgs/$orgId": typeof AuthedModalAdminOrgsOrgIdRoute
  "/_authed/_modal/admin/users/$userId": typeof AuthedModalAdminUsersUserIdRoute
  "/_authed/_modal/console/connection-access/$connectionId": typeof AuthedModalConsoleConnectionAccessConnectionIdRoute
  "/_authed/_modal/console/connectors/$connectionId": typeof AuthedModalConsoleConnectorsConnectionIdRoute
  "/_authed/_modal/console/document-access/$documentId": typeof AuthedModalConsoleDocumentAccessDocumentIdRoute
  "/_authed/_modal/console/flows/$flowId": typeof AuthedModalConsoleFlowsFlowIdRoute
  "/_authed/_modal/console/keys/$keyId": typeof AuthedModalConsoleKeysKeyIdRoute
  "/_authed/workspace/flows/$flowId_/run": typeof AuthedWorkspaceFlowsFlowIdRunRoute
  "/_authed/workspace/templates/edit/$slug": typeof AuthedWorkspaceTemplatesEditSlugRoute
  "/_authed/_modal/admin/orgs/": typeof AuthedModalAdminOrgsIndexRoute
  "/_authed/_modal/admin/users/": typeof AuthedModalAdminUsersIndexRoute
  "/_authed/_modal/console/connectors/": typeof AuthedModalConsoleConnectorsIndexRoute
  "/_authed/_modal/console/flows/": typeof AuthedModalConsoleFlowsIndexRoute
  "/_authed/_modal/console/keys/": typeof AuthedModalConsoleKeysIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/login"
    | "/auth/callback"
    | "/forms/$flowId"
    | "/admin"
    | "/console"
    | "/integrations"
    | "/settings"
    | "/workspace/integrations"
    | "/workspace/projects"
    | "/workspace/reports"
    | "/workspace/templates"
    | "/workspace/automations"
    | "/workspace/calendar"
    | "/workspace/canvases"
    | "/workspace/clean-control"
    | "/workspace/connect"
    | "/workspace/conversations"
    | "/workspace/dashboard"
    | "/workspace/documents"
    | "/workspace/dxf-library"
    | "/workspace/finance"
    | "/workspace/flows"
    | "/workspace/sales"
    | "/workspace/shares"
    | "/workspace/technical"
    | "/workspace/work"
    | "/connect/chatbot/$publicToken"
    | "/connect/invite/$token"
    | "/connect/space/$spaceId"
    | "/public/voice-report/$token"
    | "/workspace/"
    | "/admin/automation"
    | "/admin/billing"
    | "/admin/canvas"
    | "/admin/cost-tracking"
    | "/admin/demo-inviti"
    | "/admin/engagement"
    | "/admin/health"
    | "/admin/hypermem"
    | "/admin/platform-settings"
    | "/admin/presentazioni"
    | "/admin/preventivi"
    | "/admin/pricing-markup"
    | "/admin/quality"
    | "/admin/revenue"
    | "/console/access"
    | "/console/accounts"
    | "/console/actions"
    | "/console/apps"
    | "/console/billing"
    | "/console/developers"
    | "/console/docs"
    | "/console/documents"
    | "/console/embedded-identity"
    | "/console/get-started"
    | "/console/limits"
    | "/console/members"
    | "/console/models"
    | "/console/playground"
    | "/console/schema"
    | "/console/traces"
    | "/console/usage"
    | "/engine/get-started"
    | "/integrations/$capability"
    | "/settings/billing"
    | "/settings/brand-kits"
    | "/settings/changelog"
    | "/settings/help"
    | "/settings/marp-templates"
    | "/settings/memory"
    | "/settings/modes"
    | "/settings/notifications"
    | "/settings/organization"
    | "/settings/presentations"
    | "/settings/privacy"
    | "/settings/security"
    | "/settings/shortcuts"
    | "/settings/skills"
    | "/workspace/canvases/$canvasId"
    | "/workspace/connect/$spaceId"
    | "/workspace/dashboard/$dashboardId"
    | "/workspace/flows/$flowId"
    | "/workspace/integrations/$capability"
    | "/workspace/projects/$projectId"
    | "/workspace/reports/$reportId"
    | "/workspace/templates/$kind"
    | "/admin/"
    | "/console/"
    | "/integrations/"
    | "/settings/"
    | "/workspace/connect/"
    | "/workspace/flows/"
    | "/workspace/integrations/"
    | "/workspace/projects/"
    | "/workspace/reports/"
    | "/workspace/templates/"
    | "/admin/orgs/$orgId"
    | "/admin/users/$userId"
    | "/console/connection-access/$connectionId"
    | "/console/connectors/$connectionId"
    | "/console/document-access/$documentId"
    | "/console/flows/$flowId"
    | "/console/keys/$keyId"
    | "/workspace/flows/$flowId/run"
    | "/workspace/templates/edit/$slug"
    | "/admin/orgs/"
    | "/admin/users/"
    | "/console/connectors/"
    | "/console/flows/"
    | "/console/keys/"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/login"
    | "/"
    | "/auth/callback"
    | "/forms/$flowId"
    | "/workspace/automations"
    | "/workspace/calendar"
    | "/workspace/canvases"
    | "/workspace/clean-control"
    | "/workspace/conversations"
    | "/workspace/dashboard"
    | "/workspace/documents"
    | "/workspace/dxf-library"
    | "/workspace/finance"
    | "/workspace/sales"
    | "/workspace/shares"
    | "/workspace/technical"
    | "/workspace/work"
    | "/connect/chatbot/$publicToken"
    | "/connect/invite/$token"
    | "/connect/space/$spaceId"
    | "/public/voice-report/$token"
    | "/workspace"
    | "/admin/automation"
    | "/admin/billing"
    | "/admin/canvas"
    | "/admin/cost-tracking"
    | "/admin/demo-inviti"
    | "/admin/engagement"
    | "/admin/health"
    | "/admin/hypermem"
    | "/admin/platform-settings"
    | "/admin/presentazioni"
    | "/admin/preventivi"
    | "/admin/pricing-markup"
    | "/admin/quality"
    | "/admin/revenue"
    | "/console/access"
    | "/console/accounts"
    | "/console/actions"
    | "/console/apps"
    | "/console/billing"
    | "/console/developers"
    | "/console/docs"
    | "/console/documents"
    | "/console/embedded-identity"
    | "/console/get-started"
    | "/console/limits"
    | "/console/members"
    | "/console/models"
    | "/console/playground"
    | "/console/schema"
    | "/console/traces"
    | "/console/usage"
    | "/engine/get-started"
    | "/integrations/$capability"
    | "/settings/billing"
    | "/settings/brand-kits"
    | "/settings/changelog"
    | "/settings/help"
    | "/settings/marp-templates"
    | "/settings/memory"
    | "/settings/modes"
    | "/settings/notifications"
    | "/settings/organization"
    | "/settings/presentations"
    | "/settings/privacy"
    | "/settings/security"
    | "/settings/shortcuts"
    | "/settings/skills"
    | "/workspace/canvases/$canvasId"
    | "/workspace/connect/$spaceId"
    | "/workspace/dashboard/$dashboardId"
    | "/workspace/flows/$flowId"
    | "/workspace/integrations/$capability"
    | "/workspace/projects/$projectId"
    | "/workspace/reports/$reportId"
    | "/workspace/templates/$kind"
    | "/admin"
    | "/console"
    | "/integrations"
    | "/settings"
    | "/workspace/connect"
    | "/workspace/flows"
    | "/workspace/integrations"
    | "/workspace/projects"
    | "/workspace/reports"
    | "/workspace/templates"
    | "/admin/orgs/$orgId"
    | "/admin/users/$userId"
    | "/console/connection-access/$connectionId"
    | "/console/connectors/$connectionId"
    | "/console/document-access/$documentId"
    | "/console/flows/$flowId"
    | "/console/keys/$keyId"
    | "/workspace/flows/$flowId/run"
    | "/workspace/templates/edit/$slug"
    | "/admin/orgs"
    | "/admin/users"
    | "/console/connectors"
    | "/console/flows"
    | "/console/keys"
  id:
    | "__root__"
    | "/_authed"
    | "/login"
    | "/_authed/_modal"
    | "/auth/callback"
    | "/forms/$flowId"
    | "/_authed/"
    | "/_authed/_modal/admin"
    | "/_authed/_modal/console"
    | "/_authed/_modal/integrations"
    | "/_authed/_modal/settings"
    | "/_authed/workspace/integrations"
    | "/_authed/workspace/projects"
    | "/_authed/workspace/reports"
    | "/_authed/workspace/templates"
    | "/_authed/workspace/automations"
    | "/_authed/workspace/calendar"
    | "/_authed/workspace/canvases"
    | "/_authed/workspace/clean-control"
    | "/_authed/workspace/connect"
    | "/_authed/workspace/conversations"
    | "/_authed/workspace/dashboard"
    | "/_authed/workspace/documents"
    | "/_authed/workspace/dxf-library"
    | "/_authed/workspace/finance"
    | "/_authed/workspace/flows"
    | "/_authed/workspace/sales"
    | "/_authed/workspace/shares"
    | "/_authed/workspace/technical"
    | "/_authed/workspace/work"
    | "/connect/chatbot/$publicToken"
    | "/connect/invite/$token"
    | "/connect/space/$spaceId"
    | "/public/voice-report/$token"
    | "/_authed/workspace/"
    | "/_authed/_modal/admin/automation"
    | "/_authed/_modal/admin/billing"
    | "/_authed/_modal/admin/canvas"
    | "/_authed/_modal/admin/cost-tracking"
    | "/_authed/_modal/admin/demo-inviti"
    | "/_authed/_modal/admin/engagement"
    | "/_authed/_modal/admin/health"
    | "/_authed/_modal/admin/hypermem"
    | "/_authed/_modal/admin/platform-settings"
    | "/_authed/_modal/admin/presentazioni"
    | "/_authed/_modal/admin/preventivi"
    | "/_authed/_modal/admin/pricing-markup"
    | "/_authed/_modal/admin/quality"
    | "/_authed/_modal/admin/revenue"
    | "/_authed/_modal/console/access"
    | "/_authed/_modal/console/accounts"
    | "/_authed/_modal/console/actions"
    | "/_authed/_modal/console/apps"
    | "/_authed/_modal/console/billing"
    | "/_authed/_modal/console/developers"
    | "/_authed/_modal/console/docs"
    | "/_authed/_modal/console/documents"
    | "/_authed/_modal/console/embedded-identity"
    | "/_authed/_modal/console/get-started"
    | "/_authed/_modal/console/limits"
    | "/_authed/_modal/console/members"
    | "/_authed/_modal/console/models"
    | "/_authed/_modal/console/playground"
    | "/_authed/_modal/console/schema"
    | "/_authed/_modal/console/traces"
    | "/_authed/_modal/console/usage"
    | "/_authed/_modal/engine/get-started"
    | "/_authed/_modal/integrations/$capability"
    | "/_authed/_modal/settings/billing"
    | "/_authed/_modal/settings/brand-kits"
    | "/_authed/_modal/settings/changelog"
    | "/_authed/_modal/settings/help"
    | "/_authed/_modal/settings/marp-templates"
    | "/_authed/_modal/settings/memory"
    | "/_authed/_modal/settings/modes"
    | "/_authed/_modal/settings/notifications"
    | "/_authed/_modal/settings/organization"
    | "/_authed/_modal/settings/presentations"
    | "/_authed/_modal/settings/privacy"
    | "/_authed/_modal/settings/security"
    | "/_authed/_modal/settings/shortcuts"
    | "/_authed/_modal/settings/skills"
    | "/_authed/workspace/canvases/$canvasId"
    | "/_authed/workspace/connect/$spaceId"
    | "/_authed/workspace/dashboard_/$dashboardId"
    | "/_authed/workspace/flows/$flowId"
    | "/_authed/workspace/integrations/$capability"
    | "/_authed/workspace/projects/$projectId"
    | "/_authed/workspace/reports/$reportId"
    | "/_authed/workspace/templates/$kind"
    | "/_authed/_modal/admin/"
    | "/_authed/_modal/console/"
    | "/_authed/_modal/integrations/"
    | "/_authed/_modal/settings/"
    | "/_authed/workspace/connect/"
    | "/_authed/workspace/flows/"
    | "/_authed/workspace/integrations/"
    | "/_authed/workspace/projects/"
    | "/_authed/workspace/reports/"
    | "/_authed/workspace/templates/"
    | "/_authed/_modal/admin/orgs/$orgId"
    | "/_authed/_modal/admin/users/$userId"
    | "/_authed/_modal/console/connection-access/$connectionId"
    | "/_authed/_modal/console/connectors/$connectionId"
    | "/_authed/_modal/console/document-access/$documentId"
    | "/_authed/_modal/console/flows/$flowId"
    | "/_authed/_modal/console/keys/$keyId"
    | "/_authed/workspace/flows/$flowId_/run"
    | "/_authed/workspace/templates/edit/$slug"
    | "/_authed/_modal/admin/orgs/"
    | "/_authed/_modal/admin/users/"
    | "/_authed/_modal/console/connectors/"
    | "/_authed/_modal/console/flows/"
    | "/_authed/_modal/console/keys/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRouteRoute: typeof AuthedRouteRouteWithChildren
  LoginRoute: typeof LoginRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  FormsFlowIdRoute: typeof FormsFlowIdRoute
  ConnectChatbotPublicTokenRoute: typeof ConnectChatbotPublicTokenRoute
  ConnectInviteTokenRoute: typeof ConnectInviteTokenRoute
  ConnectSpaceSpaceIdRoute: typeof ConnectSpaceSpaceIdRoute
  PublicVoiceReportTokenRoute: typeof PublicVoiceReportTokenRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/login": {
      id: "/login"
      path: "/login"
      fullPath: "/login"
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authed": {
      id: "/_authed"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof AuthedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authed/": {
      id: "/_authed/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/forms/$flowId": {
      id: "/forms/$flowId"
      path: "/forms/$flowId"
      fullPath: "/forms/$flowId"
      preLoaderRoute: typeof FormsFlowIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/auth/callback": {
      id: "/auth/callback"
      path: "/auth/callback"
      fullPath: "/auth/callback"
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authed/_modal": {
      id: "/_authed/_modal"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof AuthedModalRouteRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/workspace/": {
      id: "/_authed/workspace/"
      path: "/workspace"
      fullPath: "/workspace/"
      preLoaderRoute: typeof AuthedWorkspaceIndexRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/public/voice-report/$token": {
      id: "/public/voice-report/$token"
      path: "/public/voice-report/$token"
      fullPath: "/public/voice-report/$token"
      preLoaderRoute: typeof PublicVoiceReportTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/connect/space/$spaceId": {
      id: "/connect/space/$spaceId"
      path: "/connect/space/$spaceId"
      fullPath: "/connect/space/$spaceId"
      preLoaderRoute: typeof ConnectSpaceSpaceIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/connect/invite/$token": {
      id: "/connect/invite/$token"
      path: "/connect/invite/$token"
      fullPath: "/connect/invite/$token"
      preLoaderRoute: typeof ConnectInviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/connect/chatbot/$publicToken": {
      id: "/connect/chatbot/$publicToken"
      path: "/connect/chatbot/$publicToken"
      fullPath: "/connect/chatbot/$publicToken"
      preLoaderRoute: typeof ConnectChatbotPublicTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authed/workspace/work": {
      id: "/_authed/workspace/work"
      path: "/workspace/work"
      fullPath: "/workspace/work"
      preLoaderRoute: typeof AuthedWorkspaceWorkRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/workspace/technical": {
      id: "/_authed/workspace/technical"
      path: "/workspace/technical"
      fullPath: "/workspace/technical"
      preLoaderRoute: typeof AuthedWorkspaceTechnicalRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/workspace/shares": {
      id: "/_authed/workspace/shares"
      path: "/workspace/shares"
      fullPath: "/workspace/shares"
      preLoaderRoute: typeof AuthedWorkspaceSharesRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/workspace/sales": {
      id: "/_authed/workspace/sales"
      path: "/workspace/sales"
      fullPath: "/workspace/sales"
      preLoaderRoute: typeof AuthedWorkspaceSalesRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/workspace/flows": {
      id: "/_authed/workspace/flows"
      path: "/workspace/flows"
      fullPath: "/workspace/flows"
      preLoaderRoute: typeof AuthedWorkspaceFlowsRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/workspace/finance": {
      id: "/_authed/workspace/finance"
      path: "/workspace/finance"
      fullPath: "/workspace/finance"
      preLoaderRoute: typeof AuthedWorkspaceFinanceRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/workspace/dxf-library": {
      id: "/_authed/workspace/dxf-library"
      path: "/workspace/dxf-library"
      fullPath: "/workspace/dxf-library"
      preLoaderRoute: typeof AuthedWorkspaceDxfLibraryRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/workspace/documents": {
      id: "/_authed/workspace/documents"
      path: "/workspace/documents"
      fullPath: "/workspace/documents"
      preLoaderRoute: typeof AuthedWorkspaceDocumentsRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/workspace/dashboard": {
      id: "/_authed/workspace/dashboard"
      path: "/workspace/dashboard"
      fullPath: "/workspace/dashboard"
      preLoaderRoute: typeof AuthedWorkspaceDashboardRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/workspace/conversations": {
      id: "/_authed/workspace/conversations"
      path: "/workspace/conversations"
      fullPath: "/workspace/conversations"
      preLoaderRoute: typeof AuthedWorkspaceConversationsRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/workspace/connect": {
      id: "/_authed/workspace/connect"
      path: "/workspace/connect"
      fullPath: "/workspace/connect"
      preLoaderRoute: typeof AuthedWorkspaceConnectRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/workspace/clean-control": {
      id: "/_authed/workspace/clean-control"
      path: "/workspace/clean-control"
      fullPath: "/workspace/clean-control"
      preLoaderRoute: typeof AuthedWorkspaceCleanControlRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/workspace/canvases": {
      id: "/_authed/workspace/canvases"
      path: "/workspace/canvases"
      fullPath: "/workspace/canvases"
      preLoaderRoute: typeof AuthedWorkspaceCanvasesRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/workspace/calendar": {
      id: "/_authed/workspace/calendar"
      path: "/workspace/calendar"
      fullPath: "/workspace/calendar"
      preLoaderRoute: typeof AuthedWorkspaceCalendarRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/workspace/automations": {
      id: "/_authed/workspace/automations"
      path: "/workspace/automations"
      fullPath: "/workspace/automations"
      preLoaderRoute: typeof AuthedWorkspaceAutomationsRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/workspace/templates": {
      id: "/_authed/workspace/templates"
      path: "/workspace/templates"
      fullPath: "/workspace/templates"
      preLoaderRoute: typeof AuthedWorkspaceTemplatesRouteRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/workspace/reports": {
      id: "/_authed/workspace/reports"
      path: "/workspace/reports"
      fullPath: "/workspace/reports"
      preLoaderRoute: typeof AuthedWorkspaceReportsRouteRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/workspace/projects": {
      id: "/_authed/workspace/projects"
      path: "/workspace/projects"
      fullPath: "/workspace/projects"
      preLoaderRoute: typeof AuthedWorkspaceProjectsRouteRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/workspace/integrations": {
      id: "/_authed/workspace/integrations"
      path: "/workspace/integrations"
      fullPath: "/workspace/integrations"
      preLoaderRoute: typeof AuthedWorkspaceIntegrationsRouteRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/_modal/settings": {
      id: "/_authed/_modal/settings"
      path: "/settings"
      fullPath: "/settings"
      preLoaderRoute: typeof AuthedModalSettingsRouteRouteImport
      parentRoute: typeof AuthedModalRouteRoute
    }
    "/_authed/_modal/integrations": {
      id: "/_authed/_modal/integrations"
      path: "/integrations"
      fullPath: "/integrations"
      preLoaderRoute: typeof AuthedModalIntegrationsRouteRouteImport
      parentRoute: typeof AuthedModalRouteRoute
    }
    "/_authed/_modal/console": {
      id: "/_authed/_modal/console"
      path: "/console"
      fullPath: "/console"
      preLoaderRoute: typeof AuthedModalConsoleRouteRouteImport
      parentRoute: typeof AuthedModalRouteRoute
    }
    "/_authed/_modal/admin": {
      id: "/_authed/_modal/admin"
      path: "/admin"
      fullPath: "/admin"
      preLoaderRoute: typeof AuthedModalAdminRouteRouteImport
      parentRoute: typeof AuthedModalRouteRoute
    }
    "/_authed/workspace/templates/": {
      id: "/_authed/workspace/templates/"
      path: "/"
      fullPath: "/workspace/templates/"
      preLoaderRoute: typeof AuthedWorkspaceTemplatesIndexRouteImport
      parentRoute: typeof AuthedWorkspaceTemplatesRouteRoute
    }
    "/_authed/workspace/reports/": {
      id: "/_authed/workspace/reports/"
      path: "/"
      fullPath: "/workspace/reports/"
      preLoaderRoute: typeof AuthedWorkspaceReportsIndexRouteImport
      parentRoute: typeof AuthedWorkspaceReportsRouteRoute
    }
    "/_authed/workspace/projects/": {
      id: "/_authed/workspace/projects/"
      path: "/"
      fullPath: "/workspace/projects/"
      preLoaderRoute: typeof AuthedWorkspaceProjectsIndexRouteImport
      parentRoute: typeof AuthedWorkspaceProjectsRouteRoute
    }
    "/_authed/workspace/integrations/": {
      id: "/_authed/workspace/integrations/"
      path: "/"
      fullPath: "/workspace/integrations/"
      preLoaderRoute: typeof AuthedWorkspaceIntegrationsIndexRouteImport
      parentRoute: typeof AuthedWorkspaceIntegrationsRouteRoute
    }
    "/_authed/workspace/flows/": {
      id: "/_authed/workspace/flows/"
      path: "/"
      fullPath: "/workspace/flows/"
      preLoaderRoute: typeof AuthedWorkspaceFlowsIndexRouteImport
      parentRoute: typeof AuthedWorkspaceFlowsRoute
    }
    "/_authed/workspace/connect/": {
      id: "/_authed/workspace/connect/"
      path: "/"
      fullPath: "/workspace/connect/"
      preLoaderRoute: typeof AuthedWorkspaceConnectIndexRouteImport
      parentRoute: typeof AuthedWorkspaceConnectRoute
    }
    "/_authed/_modal/settings/": {
      id: "/_authed/_modal/settings/"
      path: "/"
      fullPath: "/settings/"
      preLoaderRoute: typeof AuthedModalSettingsIndexRouteImport
      parentRoute: typeof AuthedModalSettingsRouteRoute
    }
    "/_authed/_modal/integrations/": {
      id: "/_authed/_modal/integrations/"
      path: "/"
      fullPath: "/integrations/"
      preLoaderRoute: typeof AuthedModalIntegrationsIndexRouteImport
      parentRoute: typeof AuthedModalIntegrationsRouteRoute
    }
    "/_authed/_modal/console/": {
      id: "/_authed/_modal/console/"
      path: "/"
      fullPath: "/console/"
      preLoaderRoute: typeof AuthedModalConsoleIndexRouteImport
      parentRoute: typeof AuthedModalConsoleRouteRoute
    }
    "/_authed/_modal/admin/": {
      id: "/_authed/_modal/admin/"
      path: "/"
      fullPath: "/admin/"
      preLoaderRoute: typeof AuthedModalAdminIndexRouteImport
      parentRoute: typeof AuthedModalAdminRouteRoute
    }
    "/_authed/workspace/templates/$kind": {
      id: "/_authed/workspace/templates/$kind"
      path: "/$kind"
      fullPath: "/workspace/templates/$kind"
      preLoaderRoute: typeof AuthedWorkspaceTemplatesKindRouteImport
      parentRoute: typeof AuthedWorkspaceTemplatesRouteRoute
    }
    "/_authed/workspace/reports/$reportId": {
      id: "/_authed/workspace/reports/$reportId"
      path: "/$reportId"
      fullPath: "/workspace/reports/$reportId"
      preLoaderRoute: typeof AuthedWorkspaceReportsReportIdRouteImport
      parentRoute: typeof AuthedWorkspaceReportsRouteRoute
    }
    "/_authed/workspace/projects/$projectId": {
      id: "/_authed/workspace/projects/$projectId"
      path: "/$projectId"
      fullPath: "/workspace/projects/$projectId"
      preLoaderRoute: typeof AuthedWorkspaceProjectsProjectIdRouteImport
      parentRoute: typeof AuthedWorkspaceProjectsRouteRoute
    }
    "/_authed/workspace/integrations/$capability": {
      id: "/_authed/workspace/integrations/$capability"
      path: "/$capability"
      fullPath: "/workspace/integrations/$capability"
      preLoaderRoute: typeof AuthedWorkspaceIntegrationsCapabilityRouteImport
      parentRoute: typeof AuthedWorkspaceIntegrationsRouteRoute
    }
    "/_authed/workspace/flows/$flowId": {
      id: "/_authed/workspace/flows/$flowId"
      path: "/$flowId"
      fullPath: "/workspace/flows/$flowId"
      preLoaderRoute: typeof AuthedWorkspaceFlowsFlowIdRouteImport
      parentRoute: typeof AuthedWorkspaceFlowsRoute
    }
    "/_authed/workspace/dashboard_/$dashboardId": {
      id: "/_authed/workspace/dashboard_/$dashboardId"
      path: "/workspace/dashboard/$dashboardId"
      fullPath: "/workspace/dashboard/$dashboardId"
      preLoaderRoute: typeof AuthedWorkspaceDashboardDashboardIdRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    "/_authed/workspace/connect/$spaceId": {
      id: "/_authed/workspace/connect/$spaceId"
      path: "/$spaceId"
      fullPath: "/workspace/connect/$spaceId"
      preLoaderRoute: typeof AuthedWorkspaceConnectSpaceIdRouteImport
      parentRoute: typeof AuthedWorkspaceConnectRoute
    }
    "/_authed/workspace/canvases/$canvasId": {
      id: "/_authed/workspace/canvases/$canvasId"
      path: "/$canvasId"
      fullPath: "/workspace/canvases/$canvasId"
      preLoaderRoute: typeof AuthedWorkspaceCanvasesCanvasIdRouteImport
      parentRoute: typeof AuthedWorkspaceCanvasesRoute
    }
    "/_authed/_modal/settings/skills": {
      id: "/_authed/_modal/settings/skills"
      path: "/skills"
      fullPath: "/settings/skills"
      preLoaderRoute: typeof AuthedModalSettingsSkillsRouteImport
      parentRoute: typeof AuthedModalSettingsRouteRoute
    }
    "/_authed/_modal/settings/shortcuts": {
      id: "/_authed/_modal/settings/shortcuts"
      path: "/shortcuts"
      fullPath: "/settings/shortcuts"
      preLoaderRoute: typeof AuthedModalSettingsShortcutsRouteImport
      parentRoute: typeof AuthedModalSettingsRouteRoute
    }
    "/_authed/_modal/settings/security": {
      id: "/_authed/_modal/settings/security"
      path: "/security"
      fullPath: "/settings/security"
      preLoaderRoute: typeof AuthedModalSettingsSecurityRouteImport
      parentRoute: typeof AuthedModalSettingsRouteRoute
    }
    "/_authed/_modal/settings/privacy": {
      id: "/_authed/_modal/settings/privacy"
      path: "/privacy"
      fullPath: "/settings/privacy"
      preLoaderRoute: typeof AuthedModalSettingsPrivacyRouteImport
      parentRoute: typeof AuthedModalSettingsRouteRoute
    }
    "/_authed/_modal/settings/presentations": {
      id: "/_authed/_modal/settings/presentations"
      path: "/presentations"
      fullPath: "/settings/presentations"
      preLoaderRoute: typeof AuthedModalSettingsPresentationsRouteImport
      parentRoute: typeof AuthedModalSettingsRouteRoute
    }
    "/_authed/_modal/settings/organization": {
      id: "/_authed/_modal/settings/organization"
      path: "/organization"
      fullPath: "/settings/organization"
      preLoaderRoute: typeof AuthedModalSettingsOrganizationRouteImport
      parentRoute: typeof AuthedModalSettingsRouteRoute
    }
    "/_authed/_modal/settings/notifications": {
      id: "/_authed/_modal/settings/notifications"
      path: "/notifications"
      fullPath: "/settings/notifications"
      preLoaderRoute: typeof AuthedModalSettingsNotificationsRouteImport
      parentRoute: typeof AuthedModalSettingsRouteRoute
    }
    "/_authed/_modal/settings/modes": {
      id: "/_authed/_modal/settings/modes"
      path: "/modes"
      fullPath: "/settings/modes"
      preLoaderRoute: typeof AuthedModalSettingsModesRouteImport
      parentRoute: typeof AuthedModalSettingsRouteRoute
    }
    "/_authed/_modal/settings/memory": {
      id: "/_authed/_modal/settings/memory"
      path: "/memory"
      fullPath: "/settings/memory"
      preLoaderRoute: typeof AuthedModalSettingsMemoryRouteImport
      parentRoute: typeof AuthedModalSettingsRouteRoute
    }
    "/_authed/_modal/settings/marp-templates": {
      id: "/_authed/_modal/settings/marp-templates"
      path: "/marp-templates"
      fullPath: "/settings/marp-templates"
      preLoaderRoute: typeof AuthedModalSettingsMarpTemplatesRouteImport
      parentRoute: typeof AuthedModalSettingsRouteRoute
    }
    "/_authed/_modal/settings/help": {
      id: "/_authed/_modal/settings/help"
      path: "/help"
      fullPath: "/settings/help"
      preLoaderRoute: typeof AuthedModalSettingsHelpRouteImport
      parentRoute: typeof AuthedModalSettingsRouteRoute
    }
    "/_authed/_modal/settings/changelog": {
      id: "/_authed/_modal/settings/changelog"
      path: "/changelog"
      fullPath: "/settings/changelog"
      preLoaderRoute: typeof AuthedModalSettingsChangelogRouteImport
      parentRoute: typeof AuthedModalSettingsRouteRoute
    }
    "/_authed/_modal/settings/brand-kits": {
      id: "/_authed/_modal/settings/brand-kits"
      path: "/brand-kits"
      fullPath: "/settings/brand-kits"
      preLoaderRoute: typeof AuthedModalSettingsBrandKitsRouteImport
      parentRoute: typeof AuthedModalSettingsRouteRoute
    }
    "/_authed/_modal/settings/billing": {
      id: "/_authed/_modal/settings/billing"
      path: "/billing"
      fullPath: "/settings/billing"
      preLoaderRoute: typeof AuthedModalSettingsBillingRouteImport
      parentRoute: typeof AuthedModalSettingsRouteRoute
    }
    "/_authed/_modal/integrations/$capability": {
      id: "/_authed/_modal/integrations/$capability"
      path: "/$capability"
      fullPath: "/integrations/$capability"
      preLoaderRoute: typeof AuthedModalIntegrationsCapabilityRouteImport
      parentRoute: typeof AuthedModalIntegrationsRouteRoute
    }
    "/_authed/_modal/engine/get-started": {
      id: "/_authed/_modal/engine/get-started"
      path: "/engine/get-started"
      fullPath: "/engine/get-started"
      preLoaderRoute: typeof AuthedModalEngineGetStartedRouteImport
      parentRoute: typeof AuthedModalRouteRoute
    }
    "/_authed/_modal/console/usage": {
      id: "/_authed/_modal/console/usage"
      path: "/usage"
      fullPath: "/console/usage"
      preLoaderRoute: typeof AuthedModalConsoleUsageRouteImport
      parentRoute: typeof AuthedModalConsoleRouteRoute
    }
    "/_authed/_modal/console/traces": {
      id: "/_authed/_modal/console/traces"
      path: "/traces"
      fullPath: "/console/traces"
      preLoaderRoute: typeof AuthedModalConsoleTracesRouteImport
      parentRoute: typeof AuthedModalConsoleRouteRoute
    }
    "/_authed/_modal/console/schema": {
      id: "/_authed/_modal/console/schema"
      path: "/schema"
      fullPath: "/console/schema"
      preLoaderRoute: typeof AuthedModalConsoleSchemaRouteImport
      parentRoute: typeof AuthedModalConsoleRouteRoute
    }
    "/_authed/_modal/console/playground": {
      id: "/_authed/_modal/console/playground"
      path: "/playground"
      fullPath: "/console/playground"
      preLoaderRoute: typeof AuthedModalConsolePlaygroundRouteImport
      parentRoute: typeof AuthedModalConsoleRouteRoute
    }
    "/_authed/_modal/console/models": {
      id: "/_authed/_modal/console/models"
      path: "/models"
      fullPath: "/console/models"
      preLoaderRoute: typeof AuthedModalConsoleModelsRouteImport
      parentRoute: typeof AuthedModalConsoleRouteRoute
    }
    "/_authed/_modal/console/members": {
      id: "/_authed/_modal/console/members"
      path: "/members"
      fullPath: "/console/members"
      preLoaderRoute: typeof AuthedModalConsoleMembersRouteImport
      parentRoute: typeof AuthedModalConsoleRouteRoute
    }
    "/_authed/_modal/console/limits": {
      id: "/_authed/_modal/console/limits"
      path: "/limits"
      fullPath: "/console/limits"
      preLoaderRoute: typeof AuthedModalConsoleLimitsRouteImport
      parentRoute: typeof AuthedModalConsoleRouteRoute
    }
    "/_authed/_modal/console/get-started": {
      id: "/_authed/_modal/console/get-started"
      path: "/get-started"
      fullPath: "/console/get-started"
      preLoaderRoute: typeof AuthedModalConsoleGetStartedRouteImport
      parentRoute: typeof AuthedModalConsoleRouteRoute
    }
    "/_authed/_modal/console/embedded-identity": {
      id: "/_authed/_modal/console/embedded-identity"
      path: "/embedded-identity"
      fullPath: "/console/embedded-identity"
      preLoaderRoute: typeof AuthedModalConsoleEmbeddedIdentityRouteImport
      parentRoute: typeof AuthedModalConsoleRouteRoute
    }
    "/_authed/_modal/console/documents": {
      id: "/_authed/_modal/console/documents"
      path: "/documents"
      fullPath: "/console/documents"
      preLoaderRoute: typeof AuthedModalConsoleDocumentsRouteImport
      parentRoute: typeof AuthedModalConsoleRouteRoute
    }
    "/_authed/_modal/console/docs": {
      id: "/_authed/_modal/console/docs"
      path: "/docs"
      fullPath: "/console/docs"
      preLoaderRoute: typeof AuthedModalConsoleDocsRouteImport
      parentRoute: typeof AuthedModalConsoleRouteRoute
    }
    "/_authed/_modal/console/developers": {
      id: "/_authed/_modal/console/developers"
      path: "/developers"
      fullPath: "/console/developers"
      preLoaderRoute: typeof AuthedModalConsoleDevelopersRouteImport
      parentRoute: typeof AuthedModalConsoleRouteRoute
    }
    "/_authed/_modal/console/billing": {
      id: "/_authed/_modal/console/billing"
      path: "/billing"
      fullPath: "/console/billing"
      preLoaderRoute: typeof AuthedModalConsoleBillingRouteImport
      parentRoute: typeof AuthedModalConsoleRouteRoute
    }
    "/_authed/_modal/console/apps": {
      id: "/_authed/_modal/console/apps"
      path: "/apps"
      fullPath: "/console/apps"
      preLoaderRoute: typeof AuthedModalConsoleAppsRouteImport
      parentRoute: typeof AuthedModalConsoleRouteRoute
    }
    "/_authed/_modal/console/actions": {
      id: "/_authed/_modal/console/actions"
      path: "/actions"
      fullPath: "/console/actions"
      preLoaderRoute: typeof AuthedModalConsoleActionsRouteImport
      parentRoute: typeof AuthedModalConsoleRouteRoute
    }
    "/_authed/_modal/console/accounts": {
      id: "/_authed/_modal/console/accounts"
      path: "/accounts"
      fullPath: "/console/accounts"
      preLoaderRoute: typeof AuthedModalConsoleAccountsRouteImport
      parentRoute: typeof AuthedModalConsoleRouteRoute
    }
    "/_authed/_modal/console/access": {
      id: "/_authed/_modal/console/access"
      path: "/access"
      fullPath: "/console/access"
      preLoaderRoute: typeof AuthedModalConsoleAccessRouteImport
      parentRoute: typeof AuthedModalConsoleRouteRoute
    }
    "/_authed/_modal/admin/revenue": {
      id: "/_authed/_modal/admin/revenue"
      path: "/revenue"
      fullPath: "/admin/revenue"
      preLoaderRoute: typeof AuthedModalAdminRevenueRouteImport
      parentRoute: typeof AuthedModalAdminRouteRoute
    }
    "/_authed/_modal/admin/quality": {
      id: "/_authed/_modal/admin/quality"
      path: "/quality"
      fullPath: "/admin/quality"
      preLoaderRoute: typeof AuthedModalAdminQualityRouteImport
      parentRoute: typeof AuthedModalAdminRouteRoute
    }
    "/_authed/_modal/admin/pricing-markup": {
      id: "/_authed/_modal/admin/pricing-markup"
      path: "/pricing-markup"
      fullPath: "/admin/pricing-markup"
      preLoaderRoute: typeof AuthedModalAdminPricingMarkupRouteImport
      parentRoute: typeof AuthedModalAdminRouteRoute
    }
    "/_authed/_modal/admin/preventivi": {
      id: "/_authed/_modal/admin/preventivi"
      path: "/preventivi"
      fullPath: "/admin/preventivi"
      preLoaderRoute: typeof AuthedModalAdminPreventiviRouteImport
      parentRoute: typeof AuthedModalAdminRouteRoute
    }
    "/_authed/_modal/admin/presentazioni": {
      id: "/_authed/_modal/admin/presentazioni"
      path: "/presentazioni"
      fullPath: "/admin/presentazioni"
      preLoaderRoute: typeof AuthedModalAdminPresentazioniRouteImport
      parentRoute: typeof AuthedModalAdminRouteRoute
    }
    "/_authed/_modal/admin/platform-settings": {
      id: "/_authed/_modal/admin/platform-settings"
      path: "/platform-settings"
      fullPath: "/admin/platform-settings"
      preLoaderRoute: typeof AuthedModalAdminPlatformSettingsRouteImport
      parentRoute: typeof AuthedModalAdminRouteRoute
    }
    "/_authed/_modal/admin/hypermem": {
      id: "/_authed/_modal/admin/hypermem"
      path: "/hypermem"
      fullPath: "/admin/hypermem"
      preLoaderRoute: typeof AuthedModalAdminHypermemRouteImport
      parentRoute: typeof AuthedModalAdminRouteRoute
    }
    "/_authed/_modal/admin/health": {
      id: "/_authed/_modal/admin/health"
      path: "/health"
      fullPath: "/admin/health"
      preLoaderRoute: typeof AuthedModalAdminHealthRouteImport
      parentRoute: typeof AuthedModalAdminRouteRoute
    }
    "/_authed/_modal/admin/engagement": {
      id: "/_authed/_modal/admin/engagement"
      path: "/engagement"
      fullPath: "/admin/engagement"
      preLoaderRoute: typeof AuthedModalAdminEngagementRouteImport
      parentRoute: typeof AuthedModalAdminRouteRoute
    }
    "/_authed/_modal/admin/demo-inviti": {
      id: "/_authed/_modal/admin/demo-inviti"
      path: "/demo-inviti"
      fullPath: "/admin/demo-inviti"
      preLoaderRoute: typeof AuthedModalAdminDemoInvitiRouteImport
      parentRoute: typeof AuthedModalAdminRouteRoute
    }
    "/_authed/_modal/admin/cost-tracking": {
      id: "/_authed/_modal/admin/cost-tracking"
      path: "/cost-tracking"
      fullPath: "/admin/cost-tracking"
      preLoaderRoute: typeof AuthedModalAdminCostTrackingRouteImport
      parentRoute: typeof AuthedModalAdminRouteRoute
    }
    "/_authed/_modal/admin/canvas": {
      id: "/_authed/_modal/admin/canvas"
      path: "/canvas"
      fullPath: "/admin/canvas"
      preLoaderRoute: typeof AuthedModalAdminCanvasRouteImport
      parentRoute: typeof AuthedModalAdminRouteRoute
    }
    "/_authed/_modal/admin/billing": {
      id: "/_authed/_modal/admin/billing"
      path: "/billing"
      fullPath: "/admin/billing"
      preLoaderRoute: typeof AuthedModalAdminBillingRouteImport
      parentRoute: typeof AuthedModalAdminRouteRoute
    }
    "/_authed/_modal/admin/automation": {
      id: "/_authed/_modal/admin/automation"
      path: "/automation"
      fullPath: "/admin/automation"
      preLoaderRoute: typeof AuthedModalAdminAutomationRouteImport
      parentRoute: typeof AuthedModalAdminRouteRoute
    }
    "/_authed/_modal/console/keys/": {
      id: "/_authed/_modal/console/keys/"
      path: "/keys"
      fullPath: "/console/keys/"
      preLoaderRoute: typeof AuthedModalConsoleKeysIndexRouteImport
      parentRoute: typeof AuthedModalConsoleRouteRoute
    }
    "/_authed/_modal/console/flows/": {
      id: "/_authed/_modal/console/flows/"
      path: "/flows"
      fullPath: "/console/flows/"
      preLoaderRoute: typeof AuthedModalConsoleFlowsIndexRouteImport
      parentRoute: typeof AuthedModalConsoleRouteRoute
    }
    "/_authed/_modal/console/connectors/": {
      id: "/_authed/_modal/console/connectors/"
      path: "/connectors"
      fullPath: "/console/connectors/"
      preLoaderRoute: typeof AuthedModalConsoleConnectorsIndexRouteImport
      parentRoute: typeof AuthedModalConsoleRouteRoute
    }
    "/_authed/_modal/admin/users/": {
      id: "/_authed/_modal/admin/users/"
      path: "/users"
      fullPath: "/admin/users/"
      preLoaderRoute: typeof AuthedModalAdminUsersIndexRouteImport
      parentRoute: typeof AuthedModalAdminRouteRoute
    }
    "/_authed/_modal/admin/orgs/": {
      id: "/_authed/_modal/admin/orgs/"
      path: "/orgs"
      fullPath: "/admin/orgs/"
      preLoaderRoute: typeof AuthedModalAdminOrgsIndexRouteImport
      parentRoute: typeof AuthedModalAdminRouteRoute
    }
    "/_authed/workspace/templates/edit/$slug": {
      id: "/_authed/workspace/templates/edit/$slug"
      path: "/edit/$slug"
      fullPath: "/workspace/templates/edit/$slug"
      preLoaderRoute: typeof AuthedWorkspaceTemplatesEditSlugRouteImport
      parentRoute: typeof AuthedWorkspaceTemplatesRouteRoute
    }
    "/_authed/workspace/flows/$flowId_/run": {
      id: "/_authed/workspace/flows/$flowId_/run"
      path: "/$flowId/run"
      fullPath: "/workspace/flows/$flowId/run"
      preLoaderRoute: typeof AuthedWorkspaceFlowsFlowIdRunRouteImport
      parentRoute: typeof AuthedWorkspaceFlowsRoute
    }
    "/_authed/_modal/console/keys/$keyId": {
      id: "/_authed/_modal/console/keys/$keyId"
      path: "/keys/$keyId"
      fullPath: "/console/keys/$keyId"
      preLoaderRoute: typeof AuthedModalConsoleKeysKeyIdRouteImport
      parentRoute: typeof AuthedModalConsoleRouteRoute
    }
    "/_authed/_modal/console/flows/$flowId": {
      id: "/_authed/_modal/console/flows/$flowId"
      path: "/flows/$flowId"
      fullPath: "/console/flows/$flowId"
      preLoaderRoute: typeof AuthedModalConsoleFlowsFlowIdRouteImport
      parentRoute: typeof AuthedModalConsoleRouteRoute
    }
    "/_authed/_modal/console/document-access/$documentId": {
      id: "/_authed/_modal/console/document-access/$documentId"
      path: "/document-access/$documentId"
      fullPath: "/console/document-access/$documentId"
      preLoaderRoute: typeof AuthedModalConsoleDocumentAccessDocumentIdRouteImport
      parentRoute: typeof AuthedModalConsoleRouteRoute
    }
    "/_authed/_modal/console/connectors/$connectionId": {
      id: "/_authed/_modal/console/connectors/$connectionId"
      path: "/connectors/$connectionId"
      fullPath: "/console/connectors/$connectionId"
      preLoaderRoute: typeof AuthedModalConsoleConnectorsConnectionIdRouteImport
      parentRoute: typeof AuthedModalConsoleRouteRoute
    }
    "/_authed/_modal/console/connection-access/$connectionId": {
      id: "/_authed/_modal/console/connection-access/$connectionId"
      path: "/connection-access/$connectionId"
      fullPath: "/console/connection-access/$connectionId"
      preLoaderRoute: typeof AuthedModalConsoleConnectionAccessConnectionIdRouteImport
      parentRoute: typeof AuthedModalConsoleRouteRoute
    }
    "/_authed/_modal/admin/users/$userId": {
      id: "/_authed/_modal/admin/users/$userId"
      path: "/users/$userId"
      fullPath: "/admin/users/$userId"
      preLoaderRoute: typeof AuthedModalAdminUsersUserIdRouteImport
      parentRoute: typeof AuthedModalAdminRouteRoute
    }
    "/_authed/_modal/admin/orgs/$orgId": {
      id: "/_authed/_modal/admin/orgs/$orgId"
      path: "/orgs/$orgId"
      fullPath: "/admin/orgs/$orgId"
      preLoaderRoute: typeof AuthedModalAdminOrgsOrgIdRouteImport
      parentRoute: typeof AuthedModalAdminRouteRoute
    }
  }
}

interface AuthedModalAdminRouteRouteChildren {
  AuthedModalAdminAutomationRoute: typeof AuthedModalAdminAutomationRoute
  AuthedModalAdminBillingRoute: typeof AuthedModalAdminBillingRoute
  AuthedModalAdminCanvasRoute: typeof AuthedModalAdminCanvasRoute
  AuthedModalAdminCostTrackingRoute: typeof AuthedModalAdminCostTrackingRoute
  AuthedModalAdminDemoInvitiRoute: typeof AuthedModalAdminDemoInvitiRoute
  AuthedModalAdminEngagementRoute: typeof AuthedModalAdminEngagementRoute
  AuthedModalAdminHealthRoute: typeof AuthedModalAdminHealthRoute
  AuthedModalAdminHypermemRoute: typeof AuthedModalAdminHypermemRoute
  AuthedModalAdminPlatformSettingsRoute: typeof AuthedModalAdminPlatformSettingsRoute
  AuthedModalAdminPresentazioniRoute: typeof AuthedModalAdminPresentazioniRoute
  AuthedModalAdminPreventiviRoute: typeof AuthedModalAdminPreventiviRoute
  AuthedModalAdminPricingMarkupRoute: typeof AuthedModalAdminPricingMarkupRoute
  AuthedModalAdminQualityRoute: typeof AuthedModalAdminQualityRoute
  AuthedModalAdminRevenueRoute: typeof AuthedModalAdminRevenueRoute
  AuthedModalAdminIndexRoute: typeof AuthedModalAdminIndexRoute
  AuthedModalAdminOrgsOrgIdRoute: typeof AuthedModalAdminOrgsOrgIdRoute
  AuthedModalAdminUsersUserIdRoute: typeof AuthedModalAdminUsersUserIdRoute
  AuthedModalAdminOrgsIndexRoute: typeof AuthedModalAdminOrgsIndexRoute
  AuthedModalAdminUsersIndexRoute: typeof AuthedModalAdminUsersIndexRoute
}

const AuthedModalAdminRouteRouteChildren: AuthedModalAdminRouteRouteChildren = {
  AuthedModalAdminAutomationRoute: AuthedModalAdminAutomationRoute,
  AuthedModalAdminBillingRoute: AuthedModalAdminBillingRoute,
  AuthedModalAdminCanvasRoute: AuthedModalAdminCanvasRoute,
  AuthedModalAdminCostTrackingRoute: AuthedModalAdminCostTrackingRoute,
  AuthedModalAdminDemoInvitiRoute: AuthedModalAdminDemoInvitiRoute,
  AuthedModalAdminEngagementRoute: AuthedModalAdminEngagementRoute,
  AuthedModalAdminHealthRoute: AuthedModalAdminHealthRoute,
  AuthedModalAdminHypermemRoute: AuthedModalAdminHypermemRoute,
  AuthedModalAdminPlatformSettingsRoute: AuthedModalAdminPlatformSettingsRoute,
  AuthedModalAdminPresentazioniRoute: AuthedModalAdminPresentazioniRoute,
  AuthedModalAdminPreventiviRoute: AuthedModalAdminPreventiviRoute,
  AuthedModalAdminPricingMarkupRoute: AuthedModalAdminPricingMarkupRoute,
  AuthedModalAdminQualityRoute: AuthedModalAdminQualityRoute,
  AuthedModalAdminRevenueRoute: AuthedModalAdminRevenueRoute,
  AuthedModalAdminIndexRoute: AuthedModalAdminIndexRoute,
  AuthedModalAdminOrgsOrgIdRoute: AuthedModalAdminOrgsOrgIdRoute,
  AuthedModalAdminUsersUserIdRoute: AuthedModalAdminUsersUserIdRoute,
  AuthedModalAdminOrgsIndexRoute: AuthedModalAdminOrgsIndexRoute,
  AuthedModalAdminUsersIndexRoute: AuthedModalAdminUsersIndexRoute,
}

const AuthedModalAdminRouteRouteWithChildren =
  AuthedModalAdminRouteRoute._addFileChildren(
    AuthedModalAdminRouteRouteChildren,
  )

interface AuthedModalConsoleRouteRouteChildren {
  AuthedModalConsoleAccessRoute: typeof AuthedModalConsoleAccessRoute
  AuthedModalConsoleAccountsRoute: typeof AuthedModalConsoleAccountsRoute
  AuthedModalConsoleActionsRoute: typeof AuthedModalConsoleActionsRoute
  AuthedModalConsoleAppsRoute: typeof AuthedModalConsoleAppsRoute
  AuthedModalConsoleBillingRoute: typeof AuthedModalConsoleBillingRoute
  AuthedModalConsoleDevelopersRoute: typeof AuthedModalConsoleDevelopersRoute
  AuthedModalConsoleDocsRoute: typeof AuthedModalConsoleDocsRoute
  AuthedModalConsoleDocumentsRoute: typeof AuthedModalConsoleDocumentsRoute
  AuthedModalConsoleEmbeddedIdentityRoute: typeof AuthedModalConsoleEmbeddedIdentityRoute
  AuthedModalConsoleGetStartedRoute: typeof AuthedModalConsoleGetStartedRoute
  AuthedModalConsoleLimitsRoute: typeof AuthedModalConsoleLimitsRoute
  AuthedModalConsoleMembersRoute: typeof AuthedModalConsoleMembersRoute
  AuthedModalConsoleModelsRoute: typeof AuthedModalConsoleModelsRoute
  AuthedModalConsolePlaygroundRoute: typeof AuthedModalConsolePlaygroundRoute
  AuthedModalConsoleSchemaRoute: typeof AuthedModalConsoleSchemaRoute
  AuthedModalConsoleTracesRoute: typeof AuthedModalConsoleTracesRoute
  AuthedModalConsoleUsageRoute: typeof AuthedModalConsoleUsageRoute
  AuthedModalConsoleIndexRoute: typeof AuthedModalConsoleIndexRoute
  AuthedModalConsoleConnectionAccessConnectionIdRoute: typeof AuthedModalConsoleConnectionAccessConnectionIdRoute
  AuthedModalConsoleConnectorsConnectionIdRoute: typeof AuthedModalConsoleConnectorsConnectionIdRoute
  AuthedModalConsoleDocumentAccessDocumentIdRoute: typeof AuthedModalConsoleDocumentAccessDocumentIdRoute
  AuthedModalConsoleFlowsFlowIdRoute: typeof AuthedModalConsoleFlowsFlowIdRoute
  AuthedModalConsoleKeysKeyIdRoute: typeof AuthedModalConsoleKeysKeyIdRoute
  AuthedModalConsoleConnectorsIndexRoute: typeof AuthedModalConsoleConnectorsIndexRoute
  AuthedModalConsoleFlowsIndexRoute: typeof AuthedModalConsoleFlowsIndexRoute
  AuthedModalConsoleKeysIndexRoute: typeof AuthedModalConsoleKeysIndexRoute
}

const AuthedModalConsoleRouteRouteChildren: AuthedModalConsoleRouteRouteChildren =
  {
    AuthedModalConsoleAccessRoute: AuthedModalConsoleAccessRoute,
    AuthedModalConsoleAccountsRoute: AuthedModalConsoleAccountsRoute,
    AuthedModalConsoleActionsRoute: AuthedModalConsoleActionsRoute,
    AuthedModalConsoleAppsRoute: AuthedModalConsoleAppsRoute,
    AuthedModalConsoleBillingRoute: AuthedModalConsoleBillingRoute,
    AuthedModalConsoleDevelopersRoute: AuthedModalConsoleDevelopersRoute,
    AuthedModalConsoleDocsRoute: AuthedModalConsoleDocsRoute,
    AuthedModalConsoleDocumentsRoute: AuthedModalConsoleDocumentsRoute,
    AuthedModalConsoleEmbeddedIdentityRoute:
      AuthedModalConsoleEmbeddedIdentityRoute,
    AuthedModalConsoleGetStartedRoute: AuthedModalConsoleGetStartedRoute,
    AuthedModalConsoleLimitsRoute: AuthedModalConsoleLimitsRoute,
    AuthedModalConsoleMembersRoute: AuthedModalConsoleMembersRoute,
    AuthedModalConsoleModelsRoute: AuthedModalConsoleModelsRoute,
    AuthedModalConsolePlaygroundRoute: AuthedModalConsolePlaygroundRoute,
    AuthedModalConsoleSchemaRoute: AuthedModalConsoleSchemaRoute,
    AuthedModalConsoleTracesRoute: AuthedModalConsoleTracesRoute,
    AuthedModalConsoleUsageRoute: AuthedModalConsoleUsageRoute,
    AuthedModalConsoleIndexRoute: AuthedModalConsoleIndexRoute,
    AuthedModalConsoleConnectionAccessConnectionIdRoute:
      AuthedModalConsoleConnectionAccessConnectionIdRoute,
    AuthedModalConsoleConnectorsConnectionIdRoute:
      AuthedModalConsoleConnectorsConnectionIdRoute,
    AuthedModalConsoleDocumentAccessDocumentIdRoute:
      AuthedModalConsoleDocumentAccessDocumentIdRoute,
    AuthedModalConsoleFlowsFlowIdRoute: AuthedModalConsoleFlowsFlowIdRoute,
    AuthedModalConsoleKeysKeyIdRoute: AuthedModalConsoleKeysKeyIdRoute,
    AuthedModalConsoleConnectorsIndexRoute:
      AuthedModalConsoleConnectorsIndexRoute,
    AuthedModalConsoleFlowsIndexRoute: AuthedModalConsoleFlowsIndexRoute,
    AuthedModalConsoleKeysIndexRoute: AuthedModalConsoleKeysIndexRoute,
  }

const AuthedModalConsoleRouteRouteWithChildren =
  AuthedModalConsoleRouteRoute._addFileChildren(
    AuthedModalConsoleRouteRouteChildren,
  )

interface AuthedModalIntegrationsRouteRouteChildren {
  AuthedModalIntegrationsCapabilityRoute: typeof AuthedModalIntegrationsCapabilityRoute
  AuthedModalIntegrationsIndexRoute: typeof AuthedModalIntegrationsIndexRoute
}

const AuthedModalIntegrationsRouteRouteChildren: AuthedModalIntegrationsRouteRouteChildren =
  {
    AuthedModalIntegrationsCapabilityRoute:
      AuthedModalIntegrationsCapabilityRoute,
    AuthedModalIntegrationsIndexRoute: AuthedModalIntegrationsIndexRoute,
  }

const AuthedModalIntegrationsRouteRouteWithChildren =
  AuthedModalIntegrationsRouteRoute._addFileChildren(
    AuthedModalIntegrationsRouteRouteChildren,
  )

interface AuthedModalSettingsRouteRouteChildren {
  AuthedModalSettingsBillingRoute: typeof AuthedModalSettingsBillingRoute
  AuthedModalSettingsBrandKitsRoute: typeof AuthedModalSettingsBrandKitsRoute
  AuthedModalSettingsChangelogRoute: typeof AuthedModalSettingsChangelogRoute
  AuthedModalSettingsHelpRoute: typeof AuthedModalSettingsHelpRoute
  AuthedModalSettingsMarpTemplatesRoute: typeof AuthedModalSettingsMarpTemplatesRoute
  AuthedModalSettingsMemoryRoute: typeof AuthedModalSettingsMemoryRoute
  AuthedModalSettingsModesRoute: typeof AuthedModalSettingsModesRoute
  AuthedModalSettingsNotificationsRoute: typeof AuthedModalSettingsNotificationsRoute
  AuthedModalSettingsOrganizationRoute: typeof AuthedModalSettingsOrganizationRoute
  AuthedModalSettingsPresentationsRoute: typeof AuthedModalSettingsPresentationsRoute
  AuthedModalSettingsPrivacyRoute: typeof AuthedModalSettingsPrivacyRoute
  AuthedModalSettingsSecurityRoute: typeof AuthedModalSettingsSecurityRoute
  AuthedModalSettingsShortcutsRoute: typeof AuthedModalSettingsShortcutsRoute
  AuthedModalSettingsSkillsRoute: typeof AuthedModalSettingsSkillsRoute
  AuthedModalSettingsIndexRoute: typeof AuthedModalSettingsIndexRoute
}

const AuthedModalSettingsRouteRouteChildren: AuthedModalSettingsRouteRouteChildren =
  {
    AuthedModalSettingsBillingRoute: AuthedModalSettingsBillingRoute,
    AuthedModalSettingsBrandKitsRoute: AuthedModalSettingsBrandKitsRoute,
    AuthedModalSettingsChangelogRoute: AuthedModalSettingsChangelogRoute,
    AuthedModalSettingsHelpRoute: AuthedModalSettingsHelpRoute,
    AuthedModalSettingsMarpTemplatesRoute:
      AuthedModalSettingsMarpTemplatesRoute,
    AuthedModalSettingsMemoryRoute: AuthedModalSettingsMemoryRoute,
    AuthedModalSettingsModesRoute: AuthedModalSettingsModesRoute,
    AuthedModalSettingsNotificationsRoute:
      AuthedModalSettingsNotificationsRoute,
    AuthedModalSettingsOrganizationRoute: AuthedModalSettingsOrganizationRoute,
    AuthedModalSettingsPresentationsRoute:
      AuthedModalSettingsPresentationsRoute,
    AuthedModalSettingsPrivacyRoute: AuthedModalSettingsPrivacyRoute,
    AuthedModalSettingsSecurityRoute: AuthedModalSettingsSecurityRoute,
    AuthedModalSettingsShortcutsRoute: AuthedModalSettingsShortcutsRoute,
    AuthedModalSettingsSkillsRoute: AuthedModalSettingsSkillsRoute,
    AuthedModalSettingsIndexRoute: AuthedModalSettingsIndexRoute,
  }

const AuthedModalSettingsRouteRouteWithChildren =
  AuthedModalSettingsRouteRoute._addFileChildren(
    AuthedModalSettingsRouteRouteChildren,
  )

interface AuthedModalRouteRouteChildren {
  AuthedModalAdminRouteRoute: typeof AuthedModalAdminRouteRouteWithChildren
  AuthedModalConsoleRouteRoute: typeof AuthedModalConsoleRouteRouteWithChildren
  AuthedModalIntegrationsRouteRoute: typeof AuthedModalIntegrationsRouteRouteWithChildren
  AuthedModalSettingsRouteRoute: typeof AuthedModalSettingsRouteRouteWithChildren
  AuthedModalEngineGetStartedRoute: typeof AuthedModalEngineGetStartedRoute
}

const AuthedModalRouteRouteChildren: AuthedModalRouteRouteChildren = {
  AuthedModalAdminRouteRoute: AuthedModalAdminRouteRouteWithChildren,
  AuthedModalConsoleRouteRoute: AuthedModalConsoleRouteRouteWithChildren,
  AuthedModalIntegrationsRouteRoute:
    AuthedModalIntegrationsRouteRouteWithChildren,
  AuthedModalSettingsRouteRoute: AuthedModalSettingsRouteRouteWithChildren,
  AuthedModalEngineGetStartedRoute: AuthedModalEngineGetStartedRoute,
}

const AuthedModalRouteRouteWithChildren =
  AuthedModalRouteRoute._addFileChildren(AuthedModalRouteRouteChildren)

interface AuthedWorkspaceIntegrationsRouteRouteChildren {
  AuthedWorkspaceIntegrationsCapabilityRoute: typeof AuthedWorkspaceIntegrationsCapabilityRoute
  AuthedWorkspaceIntegrationsIndexRoute: typeof AuthedWorkspaceIntegrationsIndexRoute
}

const AuthedWorkspaceIntegrationsRouteRouteChildren: AuthedWorkspaceIntegrationsRouteRouteChildren =
  {
    AuthedWorkspaceIntegrationsCapabilityRoute:
      AuthedWorkspaceIntegrationsCapabilityRoute,
    AuthedWorkspaceIntegrationsIndexRoute:
      AuthedWorkspaceIntegrationsIndexRoute,
  }

const AuthedWorkspaceIntegrationsRouteRouteWithChildren =
  AuthedWorkspaceIntegrationsRouteRoute._addFileChildren(
    AuthedWorkspaceIntegrationsRouteRouteChildren,
  )

interface AuthedWorkspaceProjectsRouteRouteChildren {
  AuthedWorkspaceProjectsProjectIdRoute: typeof AuthedWorkspaceProjectsProjectIdRoute
  AuthedWorkspaceProjectsIndexRoute: typeof AuthedWorkspaceProjectsIndexRoute
}

const AuthedWorkspaceProjectsRouteRouteChildren: AuthedWorkspaceProjectsRouteRouteChildren =
  {
    AuthedWorkspaceProjectsProjectIdRoute:
      AuthedWorkspaceProjectsProjectIdRoute,
    AuthedWorkspaceProjectsIndexRoute: AuthedWorkspaceProjectsIndexRoute,
  }

const AuthedWorkspaceProjectsRouteRouteWithChildren =
  AuthedWorkspaceProjectsRouteRoute._addFileChildren(
    AuthedWorkspaceProjectsRouteRouteChildren,
  )

interface AuthedWorkspaceReportsRouteRouteChildren {
  AuthedWorkspaceReportsReportIdRoute: typeof AuthedWorkspaceReportsReportIdRoute
  AuthedWorkspaceReportsIndexRoute: typeof AuthedWorkspaceReportsIndexRoute
}

const AuthedWorkspaceReportsRouteRouteChildren: AuthedWorkspaceReportsRouteRouteChildren =
  {
    AuthedWorkspaceReportsReportIdRoute: AuthedWorkspaceReportsReportIdRoute,
    AuthedWorkspaceReportsIndexRoute: AuthedWorkspaceReportsIndexRoute,
  }

const AuthedWorkspaceReportsRouteRouteWithChildren =
  AuthedWorkspaceReportsRouteRoute._addFileChildren(
    AuthedWorkspaceReportsRouteRouteChildren,
  )

interface AuthedWorkspaceTemplatesRouteRouteChildren {
  AuthedWorkspaceTemplatesKindRoute: typeof AuthedWorkspaceTemplatesKindRoute
  AuthedWorkspaceTemplatesIndexRoute: typeof AuthedWorkspaceTemplatesIndexRoute
  AuthedWorkspaceTemplatesEditSlugRoute: typeof AuthedWorkspaceTemplatesEditSlugRoute
}

const AuthedWorkspaceTemplatesRouteRouteChildren: AuthedWorkspaceTemplatesRouteRouteChildren =
  {
    AuthedWorkspaceTemplatesKindRoute: AuthedWorkspaceTemplatesKindRoute,
    AuthedWorkspaceTemplatesIndexRoute: AuthedWorkspaceTemplatesIndexRoute,
    AuthedWorkspaceTemplatesEditSlugRoute:
      AuthedWorkspaceTemplatesEditSlugRoute,
  }

const AuthedWorkspaceTemplatesRouteRouteWithChildren =
  AuthedWorkspaceTemplatesRouteRoute._addFileChildren(
    AuthedWorkspaceTemplatesRouteRouteChildren,
  )

interface AuthedWorkspaceCanvasesRouteChildren {
  AuthedWorkspaceCanvasesCanvasIdRoute: typeof AuthedWorkspaceCanvasesCanvasIdRoute
}

const AuthedWorkspaceCanvasesRouteChildren: AuthedWorkspaceCanvasesRouteChildren =
  {
    AuthedWorkspaceCanvasesCanvasIdRoute: AuthedWorkspaceCanvasesCanvasIdRoute,
  }

const AuthedWorkspaceCanvasesRouteWithChildren =
  AuthedWorkspaceCanvasesRoute._addFileChildren(
    AuthedWorkspaceCanvasesRouteChildren,
  )

interface AuthedWorkspaceConnectRouteChildren {
  AuthedWorkspaceConnectSpaceIdRoute: typeof AuthedWorkspaceConnectSpaceIdRoute
  AuthedWorkspaceConnectIndexRoute: typeof AuthedWorkspaceConnectIndexRoute
}

const AuthedWorkspaceConnectRouteChildren: AuthedWorkspaceConnectRouteChildren =
  {
    AuthedWorkspaceConnectSpaceIdRoute: AuthedWorkspaceConnectSpaceIdRoute,
    AuthedWorkspaceConnectIndexRoute: AuthedWorkspaceConnectIndexRoute,
  }

const AuthedWorkspaceConnectRouteWithChildren =
  AuthedWorkspaceConnectRoute._addFileChildren(
    AuthedWorkspaceConnectRouteChildren,
  )

interface AuthedWorkspaceFlowsRouteChildren {
  AuthedWorkspaceFlowsFlowIdRoute: typeof AuthedWorkspaceFlowsFlowIdRoute
  AuthedWorkspaceFlowsIndexRoute: typeof AuthedWorkspaceFlowsIndexRoute
  AuthedWorkspaceFlowsFlowIdRunRoute: typeof AuthedWorkspaceFlowsFlowIdRunRoute
}

const AuthedWorkspaceFlowsRouteChildren: AuthedWorkspaceFlowsRouteChildren = {
  AuthedWorkspaceFlowsFlowIdRoute: AuthedWorkspaceFlowsFlowIdRoute,
  AuthedWorkspaceFlowsIndexRoute: AuthedWorkspaceFlowsIndexRoute,
  AuthedWorkspaceFlowsFlowIdRunRoute: AuthedWorkspaceFlowsFlowIdRunRoute,
}

const AuthedWorkspaceFlowsRouteWithChildren =
  AuthedWorkspaceFlowsRoute._addFileChildren(AuthedWorkspaceFlowsRouteChildren)

interface AuthedRouteRouteChildren {
  AuthedModalRouteRoute: typeof AuthedModalRouteRouteWithChildren
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedWorkspaceIntegrationsRouteRoute: typeof AuthedWorkspaceIntegrationsRouteRouteWithChildren
  AuthedWorkspaceProjectsRouteRoute: typeof AuthedWorkspaceProjectsRouteRouteWithChildren
  AuthedWorkspaceReportsRouteRoute: typeof AuthedWorkspaceReportsRouteRouteWithChildren
  AuthedWorkspaceTemplatesRouteRoute: typeof AuthedWorkspaceTemplatesRouteRouteWithChildren
  AuthedWorkspaceAutomationsRoute: typeof AuthedWorkspaceAutomationsRoute
  AuthedWorkspaceCalendarRoute: typeof AuthedWorkspaceCalendarRoute
  AuthedWorkspaceCanvasesRoute: typeof AuthedWorkspaceCanvasesRouteWithChildren
  AuthedWorkspaceCleanControlRoute: typeof AuthedWorkspaceCleanControlRoute
  AuthedWorkspaceConnectRoute: typeof AuthedWorkspaceConnectRouteWithChildren
  AuthedWorkspaceConversationsRoute: typeof AuthedWorkspaceConversationsRoute
  AuthedWorkspaceDashboardRoute: typeof AuthedWorkspaceDashboardRoute
  AuthedWorkspaceDocumentsRoute: typeof AuthedWorkspaceDocumentsRoute
  AuthedWorkspaceDxfLibraryRoute: typeof AuthedWorkspaceDxfLibraryRoute
  AuthedWorkspaceFinanceRoute: typeof AuthedWorkspaceFinanceRoute
  AuthedWorkspaceFlowsRoute: typeof AuthedWorkspaceFlowsRouteWithChildren
  AuthedWorkspaceSalesRoute: typeof AuthedWorkspaceSalesRoute
  AuthedWorkspaceSharesRoute: typeof AuthedWorkspaceSharesRoute
  AuthedWorkspaceTechnicalRoute: typeof AuthedWorkspaceTechnicalRoute
  AuthedWorkspaceWorkRoute: typeof AuthedWorkspaceWorkRoute
  AuthedWorkspaceIndexRoute: typeof AuthedWorkspaceIndexRoute
  AuthedWorkspaceDashboardDashboardIdRoute: typeof AuthedWorkspaceDashboardDashboardIdRoute
}

const AuthedRouteRouteChildren: AuthedRouteRouteChildren = {
  AuthedModalRouteRoute: AuthedModalRouteRouteWithChildren,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedWorkspaceIntegrationsRouteRoute:
    AuthedWorkspaceIntegrationsRouteRouteWithChildren,
  AuthedWorkspaceProjectsRouteRoute:
    AuthedWorkspaceProjectsRouteRouteWithChildren,
  AuthedWorkspaceReportsRouteRoute:
    AuthedWorkspaceReportsRouteRouteWithChildren,
  AuthedWorkspaceTemplatesRouteRoute:
    AuthedWorkspaceTemplatesRouteRouteWithChildren,
  AuthedWorkspaceAutomationsRoute: AuthedWorkspaceAutomationsRoute,
  AuthedWorkspaceCalendarRoute: AuthedWorkspaceCalendarRoute,
  AuthedWorkspaceCanvasesRoute: AuthedWorkspaceCanvasesRouteWithChildren,
  AuthedWorkspaceCleanControlRoute: AuthedWorkspaceCleanControlRoute,
  AuthedWorkspaceConnectRoute: AuthedWorkspaceConnectRouteWithChildren,
  AuthedWorkspaceConversationsRoute: AuthedWorkspaceConversationsRoute,
  AuthedWorkspaceDashboardRoute: AuthedWorkspaceDashboardRoute,
  AuthedWorkspaceDocumentsRoute: AuthedWorkspaceDocumentsRoute,
  AuthedWorkspaceDxfLibraryRoute: AuthedWorkspaceDxfLibraryRoute,
  AuthedWorkspaceFinanceRoute: AuthedWorkspaceFinanceRoute,
  AuthedWorkspaceFlowsRoute: AuthedWorkspaceFlowsRouteWithChildren,
  AuthedWorkspaceSalesRoute: AuthedWorkspaceSalesRoute,
  AuthedWorkspaceSharesRoute: AuthedWorkspaceSharesRoute,
  AuthedWorkspaceTechnicalRoute: AuthedWorkspaceTechnicalRoute,
  AuthedWorkspaceWorkRoute: AuthedWorkspaceWorkRoute,
  AuthedWorkspaceIndexRoute: AuthedWorkspaceIndexRoute,
  AuthedWorkspaceDashboardDashboardIdRoute:
    AuthedWorkspaceDashboardDashboardIdRoute,
}

const AuthedRouteRouteWithChildren = AuthedRouteRoute._addFileChildren(
  AuthedRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthedRouteRoute: AuthedRouteRouteWithChildren,
  LoginRoute: LoginRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  FormsFlowIdRoute: FormsFlowIdRoute,
  ConnectChatbotPublicTokenRoute: ConnectChatbotPublicTokenRoute,
  ConnectInviteTokenRoute: ConnectInviteTokenRoute,
  ConnectSpaceSpaceIdRoute: ConnectSpaceSpaceIdRoute,
  PublicVoiceReportTokenRoute: PublicVoiceReportTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
